//import the built-in Scala files
import scale_12_edo from "scales/12edo.scl?raw";
import scale_12_mt_1_4_SC from "scales/12-MT-1_4-SC.scl?raw";
import scale_12_ji_3l from "scales/12-JI-3L.scl?raw";
import scale_12_ji_5l from "scales/12-JI-5L.scl?raw";
import scale_12_combined from "scales/12-tone-combined.scl?raw";
import scale_12_ji_7l from "scales/12-JI-7L.scl?raw";
import scale_12_ji_blues_7l from "scales/12-JI-blues-7L.scl?raw";
import scale_12_ji_7_11 from "scales/12-JI-7+11.scl?raw";
import scale_12_ji_5_13 from "scales/12-JI-5+13.scl?raw";
import scale_12_ji_sabat_I from "scales/12-JI-SabatI.scl?raw";
import scale_12_ji_sabat_II from "scales/12-JI-SabatII.scl?raw";
import scale_12_hamilton from "scales/12-Hamilton12-24_25no23.scl?raw";
import scale_12_hs from "scales/12-HS12-24_25no23.scl?raw";

import scale_17_ji_3l from "scales/17-JI-3L-Ormavi.scl?raw";
import scale_17_ji_13l from "scales/17-JI-13L-Sina.scl?raw";
import scale_22_ji_17l from "scales/22-JI-17L-Farabi.scl?raw";
import scale_22_ji_59l from "scales/22-JI-59L-SabatMaqam.scl?raw";
import scale_22_ji_5l from "scales/22-JI-5L-Indian.scl?raw";
import scale_43_ji_11l_partch from "scales/43-JI-11L-Partch.scl?raw";
import scale_43_ji_11l_partchG from "scales/43-JI-11L-Partch_on_G.scl?raw";
import scale_31_ji_7l_fokker from "scales/31-JI-7L-Fokker.scl?raw";
import scale_17_ji_11l_wilson from "scales/17-JI-11L-Wilson.scl?raw";
import scale_53_ji_13l_ct from "scales/53-JI-13L-CT.scl?raw";
import scale_41_ji_7l from "scales/41-JI-7L-Sabat-Young.scl?raw";
import scale_55_ji_5l from "scales/55-JI-5L-Sabat-Euler.scl?raw";
import scale_13_ji_7l_P5 from "scales/13-JI-7L-P5.scl?raw";

import scale_36_hs_12to48 from "scales/36-HS-12to48.scl?raw";
import scale_72_hss_12to48 from "scales/72-HSS-12to48.scl?raw";
import scale_72_shs_12to48 from "scales/72-SHS-12to48.scl?raw";
import scale_19_hs_34to52 from "scales/19-HS-34to52.scl?raw";
import scale_53_hs_53to106 from "scales/53-HS-53to106.scl?raw";
import scale_55_hs_55to110 from "scales/55-HS-55to110.scl?raw";
import scale_55_criticalband from "scales/55-CriticalBand.scl?raw";

import scale_14_hs_odd_3_5 from "scales/14-HS-odd-3+5.scl?raw";
import scale_12_hs_odd_3_7 from "scales/12-HS-odd-3+7.scl?raw";
import scale_18_hs_odd_3_7_11 from "scales/18-HS-odd-3+7+11.scl?raw";
import scale_20_hs_odd_3_5_13 from "scales/20-HS-odd-3+5+13.scl?raw";
import scale_22_hs_odd_37to47 from "scales/22-HS-odd-37to47.scl?raw";
import scale_40_hs_odd_13l from "scales/40-HS-odd-13L.scl?raw";
import scale_55_hs_odd_19l from "scales/55-HS-odd-19L.scl?raw";
import scale_81_hs_odd_47l from "scales/81-HS-odd-47L.scl?raw";
import scale_53_hs_odd_mod from "scales/53-HS-odd-mod.scl?raw";

import scale_31_mt_vicentino from "scales/31-MT-Vicentino.scl?raw";
import scale_19_19P5_amt_vicentino from "scales/19+19P5-AdaptiveMT-Vicentino.scl?raw";
import scale_36_mt_sabat_helmholtz from "scales/36-MT-Sabat-Helmholtz.scl?raw";
import scale_43_mt from "scales/43-MT-1_5-Comma.scl?raw";
import scale_55_mt from "scales/55-MT-1_6-Comma.scl?raw";

import scale_19_edo from "scales/19edo.scl?raw";
import scale_22_edo from "scales/22edo.scl?raw";
import scale_31_edo from "scales/31edo.scl?raw";
import scale_41_edo from "scales/41edo.scl?raw";
import scale_43_edo from "scales/43edo.scl?raw";
import scale_53_edo from "scales/53edo.scl?raw";
import scale_55_edo from "scales/55edo.scl?raw";
import scale_72_edo from "scales/72edo.scl?raw";

import scale_1cent from "scales/1cent.scl?raw";
import scale_harp from "scales/harp.scl?raw";
import scale_55cents from "scales/55cents.scl?raw";

//import the Scala file parser, which can output scale: [], colors: [], labels: [], errors: [],
import { parseScale } from "../scale/parse-scale";

// Define the presets which appear in the sidebar menu.
// Keys are kept in JSON-style double quotes throughout so built-in presets
// visually match the syntax used for preset import/export files.

export const presets = [
  {
    "name": "Marc Sabat / NYKY Ensemble",
    "settings": [
      {
        "name": "Harry Partch: 43 tone Just Intonation scale",
        "description":
          "The classic 43-tone 11-Limit Rational Intonation scale by Harry Partch, consisting of 43 divisions per octave derived symmetrically from both harmonic and subharmonic partial rows (otonalities and utonalities) up to a prime limit of 11. The ratio notation follows Partch's original tuning, but this version is transposed so 1/1 = A (441 Hz). The open strings are the ratios 32/27 (C), 16/9 (G), 4/3 (D), 1/1 (A), and 3/2 (E).",
        "short_description": "43-JI-11LPartchA",
        "scale": [
          "81/80",
          "33/32",
          "21/20",
          "16/15",
          "12/11",
          "11/10",
          "10/9",
          "9/8",
          "8/7",
          "7/6",
          "32/27",
          "6/5",
          "11/9",
          "5/4",
          "14/11",
          "9/7",
          "21/16",
          "4/3",
          "27/20",
          "11/8",
          "7/5",
          "10/7",
          "16/11",
          "40/27",
          "3/2",
          "32/21",
          "14/9",
          "11/7",
          "8/5",
          "18/11",
          "5/3",
          "27/16",
          "12/7",
          "7/4",
          "16/9",
          "9/5",
          "20/11",
          "11/6",
          "15/8",
          "40/21",
          "64/33",
          "160/81",
          "2/1",
        ],
        "equivSteps": 43,
        "note_names": [
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "*nB",
          "B",
          "C",
          "*nC",
          "C",
          "C",
          "C",
          "D",
          "C",
          "D",
          "*nD",
          "D",
          "D",
          "E",
          "D",
          "E",
          "E",
          "*nE",
          "E",
          "F",
          "E",
          "F",
          "F",
          "F",
          "F",
          "♯F",
          "G",
          "*nG",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
        ],
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ece6df",
          "#dee2da",
          "#cee3e2",
          "#e2eecd",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#fffae5",
          "#bae5f7",
          "#e2caca",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ece6df",
          "#ecc9a2",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#cee3e2",
          "#fffae5",
          "#d0d0d7",
          "#e2caca",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#e2eecd",
          "#dfffd6",
          "#fffae5",
          "#ecc9a2",
          "#cee3e2",
          "#fffae5",
        ],
        "key_labels": "scala_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 220.5,
        "reference_degree": 0,
        "rSteps": 7,
        "drSteps": 4,
        "hexSize": 38,
        "rotation": -16.102113751,
        "center_degree": 18,
        "exquis_anchor_note": 18,
      },
      {
        "name": "Pauline Oliveros: Heart of Tones",
        "description":
          '55-tone layout of tiny 1 cent steps based on Pauline Oliveros’s "Heart of Tones". The central tone D expands outward by about a semitone on each side.',
        "short_description": "55cents_Oliveros",
        "scale_import": scale_55cents,
        "scale": parseScale(scale_55cents).scale,
        "equivSteps": 55,
        "note_names": [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "25",
          "25",
          "26",
          "27",
          "-27",
          "-26",
          "-25",
          "-24",
          "-23",
          "-22",
          "-21",
          "-20",
          "-19",
          "-18",
          "-17",
          "-16",
          "-15",
          "-14",
          "-13",
          "-12",
          "-11",
          "-10",
          "-9",
          "-8",
          "-7",
          "-6",
          "-5",
          "-4",
          "-3",
          "-2",
          "-1",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffdbdb",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 32,
        "rotation": -16.102113751,
        "fundamental": 294,
        "reference_degree": 0,
        "center_degree": 0,
        "exquis_anchor_note": 30,
      },
      {
        "name": "Chromatic Scale of Harmonic Partials over A",
        "description":
          "12-tone 23-limit Rational Intonation (JI) scale. Derived from the harmonic partial row, it is a chromatic scale of the lowest partials that fit on a standard piano keyboard: 16°, 17°, 18°, 19°, 20°, 21°, 22°, 24°, 25°, 26°, 28°, 30° over A.",
        "short_description": "12-HS_A13-26no23",
        "scale": [
          "25/24",
          "13/12",
          "7/6",
          "5/4",
          "4/3",
          "17/12",
          "3/2",
          "19/12",
          "5/3",
          "7/4",
          "11/6",
          "2/1",
        ],
        "equivSteps": 12,
        "note_names": ["E", "E", "F", "G", "G", "A", "A", "B", "C", "C", "D", "D"],
        "note_colors": [
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#d6f7ff",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 441,
        "reference_degree": 5,
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "center_degree": 5,
      },
      {
        "name": "James Tenney: Critical Band 55 tone layout",
        "description":
          '55-tone 19-Limit Rational Intonation scale, based on James Tenney’s "Critical Band". The tones fan out around A 440, beginning with very small intervals. As the frequency band widens, the chords become increasingly harmonic. The space between G-sharp and A-sharp is filled with small steps, the remaining pitch classes make a chromatic harmonic scale.',
        "short_description": "55-HS_A_TenneyCB",
        "scale_import": scale_55_criticalband,
        "scale": parseScale(scale_55_criticalband).scale,
        "equivSteps": 55,
        "note_names": [
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "127°",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffdbdb",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 441,
        "reference_degree": 0,
        "center_degree": 0,
        "exquis_anchor_note": 20,
      },
      {
        "name": "Elsie Hamilton Subharmonic Modes",
        "description":
          "12-tone 13-Limit Rational Intonation (JI) scale including the 8 note modes used by JI pioneer Elsie Hamilton (1880-1965). Inspired by Kathleen Schlesinger's research into ancient instruments and modes (The Greek Aulos), Hamilton worked with subharmonic modes which emerge naturally when instruments have holes or frets placed at equal distances. The intervals fall downward from E, A, F, D, B, following the intervals of the harmonic partials taken downward.",
        "short_description": "12-HamiltonModes",
        "scale": [
          "12/11",
          "8/7",
          "6/5",
          "5/4",
          "4/3",
          "45/32",
          "3/2",
          "8/5",
          "12/7",
          "24/13",
          "15/8",
          "2/1",
        ],
        "equivSteps": 12,
        "note_names": ["B", "C", "C", "D", "*nD", "E", "*nE", "F", "G", "G", "A", "*nA"],
        "note_colors": [
          "#d0d0d7",
          "#ffffff",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 441,
        "reference_degree": 11,
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "center_degree": 6,
        "lumatone_anchor_channel": 3,
        "lumatone_anchor_note": 26,
      },
      {
        "name": "Sabat: The Tree + Modulations",
        "description": "81-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 47. The limit chosen is the highest prime that allows each pitch to be part of an harmonic chord comprising (at least) identities 1° 3° 5°. Notated as harmonic odd partial pitch classes.",
        "short_description": "OddPartialPC-47L",
        "scale": [
          "129/128",
          "65/64",
          "33/32",
          "133/128",
          "135/128",
          "17/16",
          "69/64",
          "35/32",
          "141/128",
          "143/128",
          "9/8",
          "145/128",
          "147/128",
          "37/32",
          "75/64",
          "19/16",
          "153/128",
          "77/64",
          "155/128",
          "39/32",
          "5/4",
          "161/128",
          "81/64",
          "41/32",
          "165/128",
          "21/16",
          "169/128",
          "85/64",
          "171/128",
          "43/32",
          "87/64",
          "175/128",
          "11/8",
          "45/32",
          "91/64",
          "23/16",
          "185/128",
          "93/64",
          "187/128",
          "47/32",
          "189/128",
          "95/64",
          "3/2",
          "195/128",
          "49/32",
          "99/64",
          "25/16",
          "203/128",
          "51/32",
          "205/128",
          "207/128",
          "13/8",
          "209/128",
          "105/64",
          "215/128",
          "27/16",
          "217/128",
          "55/32",
          "221/128",
          "111/64",
          "7/4",
          "225/128",
          "57/32",
          "115/64",
          "231/128",
          "29/16",
          "117/64",
          "235/128",
          "119/64",
          "15/8",
          "121/64",
          "243/128",
          "245/128",
          "123/64",
          "247/128",
          "31/16",
          "125/64",
          "63/32",
          "253/128",
          "255/128",
          "2/1"
        ],
        "equivSteps": 81,
        "note_names": [
          "1",
          "129",
          "65",
          "33",
          "133",
          "135",
          "17",
          "69",
          "35",
          "141",
          "143",
          "9",
          "145",
          "147",
          "37",
          "75",
          "19",
          "153",
          "77",
          "155",
          "39",
          "5",
          "161",
          "81",
          "41",
          "165",
          "21",
          "169",
          "85",
          "171",
          "43",
          "87",
          "175",
          "11",
          "45",
          "91",
          "23",
          "185",
          "93",
          "187",
          "47",
          "189",
          "95",
          "3",
          "195",
          "49",
          "99",
          "25",
          "203",
          "51",
          "205",
          "207",
          "13",
          "209",
          "105",
          "215",
          "27",
          "217",
          "55",
          "221",
          "111",
          "7",
          "225",
          "57",
          "115",
          "231",
          "29",
          "117",
          "235",
          "119",
          "15",
          "121",
          "243",
          "245",
          "123",
          "247",
          "31",
          "125",
          "63",
          "253",
          "255"
        ],
        "note_colors": [
          "#ff7070",
          "#c9a573",
          "#e9d7d3",
          "#dfffd6",
          "#f4e6f2",
          "#fffae5",
          "#cfcfcf",
          "#95c69b",
          "#ffcba8",
          "#ffb8da",
          "#90f9cd",
          "#ffffff",
          "#b4cbfe",
          "#f8c9c9",
          "#cee3e2",
          "#fef5be",
          "#d6f7ff",
          "#cfcfcf",
          "#e9ecc1",
          "#0afff3",
          "#e6d7fe",
          "#fffae5",
          "#91b195",
          "#ffffff",
          "#f89b87",
          "#ddfe95",
          "#ffe5e5",
          "#dbb3ff",
          "#eceae4",
          "#d6f7ff",
          "#c9a573",
          "#8aafff",
          "#ffd270",
          "#dfffd6",
          "#fffae5",
          "#ebd0e0",
          "#95c69b",
          "#dfebdb",
          "#68f3ec",
          "#ccdbce",
          "#ffb8da",
          "#ffe5e5",
          "#e5fff9",
          "#ffffff",
          "#e9d7d3",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#b0a9fe",
          "#cfcfcf",
          "#e0b49e",
          "#95c69b",
          "#e6d7fe",
          "#caf7e3",
          "#ffcba8",
          "#e8c28c",
          "#ffffff",
          "#0fd2c8",
          "#ddfe95",
          "#c3b4d5",
          "#cee3e2",
          "#ffe5e5",
          "#fef5be",
          "#d6f7ff",
          "#90d597",
          "#e9ecc1",
          "#8aafff",
          "#e6d7fe",
          "#f79cc5",
          "#ded4d5",
          "#fffae5",
          "#c3ffad",
          "#ffffff",
          "#ffb59a",
          "#f89b87",
          "#dbe6ff",
          "#68f3ec",
          "#ffef8a",
          "#ffe5e5",
          "#69ec79",
          "#eceae4"
        ],
        "key_labels": "heji",
        "key_colors_mode": "manual",
        "fundamental_color": "#f2e3e3",
        "fundamental": 441,
        "reference_degree": 56,
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 38,
        "rotation": -16.102113751,
        "center_degree": 0,
        "lumatone_anchor_channel": 2,
        "lumatone_anchor_note": 41,
        "exquis_anchor_note": 0,
        "modulation_library": [
          {
            "sourceDegree": 0,
            "targetDegree": 43,
            "strategy": "retune_surface_to_source",
            "count": 0,
            "deltaRSteps": -2,
            "deltaDrSteps": -4,
            "transpositionDeltaCents": 498.0449991346127
          },
          {
            "sourceDegree": 0,
            "targetDegree": 11,
            "strategy": "retune_surface_to_source",
            "count": 0,
            "deltaRSteps": -1,
            "deltaDrSteps": 4,
            "transpositionDeltaCents": -203.91000173077464
          },
          {
            "sourceDegree": 0,
            "targetDegree": 56,
            "strategy": "retune_surface_in_place",
            "count": 0,
            "deltaRSteps": 0,
            "deltaDrSteps": -5,
            "transpositionDeltaCents": 294.1349974038385
          },
          {
            "sourceDegree": 0,
            "targetDegree": 21,
            "strategy": "retune_surface_to_source",
            "count": 0,
            "deltaRSteps": -1,
            "deltaDrSteps": 6,
            "transpositionDeltaCents": -386.3137138648349
          },
          {
            "sourceDegree": 0,
            "targetDegree": 61,
            "strategy": "retune_surface_to_source",
            "count": 0,
            "deltaRSteps": 0,
            "deltaDrSteps": -4,
            "transpositionDeltaCents": 231.17409353087487
          },
          {
            "sourceDegree": 0,
            "targetDegree": 33,
            "strategy": "retune_surface_to_source",
            "count": 0,
            "deltaRSteps": 2,
            "deltaDrSteps": 3,
            "transpositionDeltaCents": -551.3179423647571
          }
        ]
      }
    ],
  },
  {
    "name": "12 Note Scales",
    "settings": [
      {
        "name": "12edo (12-tone Equal Temperament)",
        "description":
          '12edo, a shorthand for "equal divisions of an octave", is the commonly used equal tempered scale. It divides an octave into 12 proportionally equal and equal sounding semitone intervals. It is notated here using HEJI (Helmholtz-Ellis JI Pitch Notation) accidentals, devised by Marc Sabat and Wolfgang von Schweinitz, 2000-2005, revised by Marc Sabat and Thomas Nicholson in 2020 with special thanks to M.O. Abbott, Catherine Lamb, and Wolfgang von Schweinitz. Fonts with embedded HEJI accidentals and unicode legends may be obtained by following the links at the bottom of this sidebar.',
        "short_description": "12edo|12-tone-ET",
        "scale_import": scale_12_edo,
        "scale": parseScale(scale_12_edo).scale,
        "equivSteps": 12,
        "note_names": [
          "C",
          "C D",
          "D",
          "D E",
          "E",
          "F",
          "F G",
          "G",
          "G A",
          "A",
          "A B",
          "B",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9d9d",
          "#c3c3d5",
          "#ededf7",
          "#c3c3d5",
          "#ededf7",
          "#ededf7",
          "#c3c3d5",
          "#ededf7",
          "#c3c3d5",
          "#ededf7",
          "#c3c3d5",
          "#ededf7",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
        "lumatone_anchor_channel": 3,
        "lumatone_anchor_note": 26,
      },
      {
        "name": "12-Pythagorean (pure fifths)",
        "description":
          "12-tone 3-Limit Rational Intonation (JI) scale. Derived from harmonic partial row intervals, it is limited to partials having only 2 and 3 as prime factors. Traditionally attributed to Pythagoras and the Pythagoreans, this tuning is also described in Ancient Mesopotamian / Akkadian and Chinese music texts, and remains in use today. A sequence of eleven perfect fifths - from D♭ through F♯ - are tuned as pure 2:3 ratios. The missing 13th note C♯ would lie one Tertial (Pythagorean) Comma (ca. 23.5 cents) higher than the D♭. Four diminished fourths – A-D♭, E-A♭, B-E♭, F♯-B♭ – are nearly pure – one schisma (ca. 2 cents) less than 4:5 ratios.",
        "short_description": "12-JI-3L_Pythag",
        "scale_import": scale_12_ji_3l,
        "scale": parseScale(scale_12_ji_3l).scale,
        "equivSteps": 12,
        "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffcccc",
          "#d0d0d7",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
          "#ffffff",
          "#dee2da",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
          "#d0d0d7",
          "#ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
      },
      {
        "name": "1/4-Comma Meantone (pure thirds)",
        "description":
          "12-tone Quarter Comma Meantone: in the range from E♭ to G♯ each fifth is narrowed by 1/4 of a Quintal (Syntonic) Comma (dividing the ratio 81/80). Eight major thirds - E♭-G, B♭-D, F-A, C-E, G-B, D-F♯, A-C♯, E-G♯ - are pure 4:5 ratios. Notated using small letter-names to distinguish that the fifths are tempered.",
        "short_description": "12-MT-1_4-SC",
        "scale_import": scale_12_mt_1_4_SC,
        "scale": parseScale(scale_12_mt_1_4_SC).scale,
        "equivSteps": 12,
        "note_names": ["c", "♯c", "d", "♭e", "e", "f", "♯f", "g", "♯g", "a", "♭b", "b"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffdbdb",
          "#eee9d3",
          "#f9f7eb",
          "#e2dfcf",
          "#f9f7eb",
          "#f9f7eb",
          "#eee9d3",
          "#f9f7eb",
          "#eee9d3",
          "#f9f7eb",
          "#e2dfcf",
          "#f9f7eb",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
      },
      {
        "name": "12-Ptolemaic (pure fifths and thirds: 5-Limit JI)",
        "description":
          "12-tone 5-Limit Rational Intonation scale, derived from harmonic partial row intervals up to a prime limit of 5. The three major and minor triads on F, C, and G are tuned pure, as 4:5:6 or 10:12:15 ratios. The fifth between D (from the triad G major) and A (from the triad F major) is 27:40, one Syntonic Comma (81/80) smaller than a pure 2:3 ratio.",
        "short_description": "12-JI-5L_Ptolemy",
        "scale_import": scale_12_ji_5l,
        "scale": parseScale(scale_12_ji_5l).scale,
        "equivSteps": 12,
        "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#ffffff",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#fffae5",
          "#dee2da",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 260.740741,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "Compare the common 12-tone systems",
        "description":
          "Four common tunings of the chromatic 12-tone scale are combined in one 48-tone layout (pitches which are the same in different tunings are repeated): 12edo (tempered HEJI accidentals), Pythagorean (uninflected accidentals), 1/4-Syntonic Comma Meantone (notated with small letters), and Ptolemaic 5-Limit JI (with additional arrows indicating the Comma alterations).",
        "short_description": "12-tone-combined",
        "scale_import": scale_12_combined,
        "scale": parseScale(scale_12_combined).scale,
        "equivSteps": 48,
        "note_names": [
          "c",
          "C",
          "C",
          "C",
          "♯c",
          "D",
          "C D",
          "D",

          "D",
          "d",
          "D",
          "D",
          "E",
          "D E",
          "♭e",
          "E",

          "e",
          "E",
          "E",
          "E",

          "F",
          "F",
          "F",
          "f",
          "♯f",
          "F",
          "F G",
          "F",

          "g",
          "G",
          "G",
          "G",
          "♯g",
          "A",
          "G A",
          "A",

          "A",
          "a",
          "A",
          "A",
          "B",
          "A B",
          "♭b",
          "B",

          "b",
          "B",
          "B",
          "B",
        ],

        "key_labels": "note_names",

        "note_colors": [
          "#f9f7eb",
          "#ffffff",
          "#ededf7",
          "#ffffff",
          "#eee9d3",
          "#d0d0d7",
          "#c3c3d5",
          "#dee2da",

          "#fffae5",
          "#f9f7eb",
          "#ededf7",
          "#ffffff",
          "#d0d0d7",
          "#c3c3d5",
          "#e2dfcf",
          "#dee2da",

          "#f9f7eb",
          "#fffae5",
          "#ededf7",
          "#ffffff",

          "#ffffff",
          "#ffffff",
          "#ededf7",
          "#f9f7eb",
          "#eee9d3",
          "#fffae5",
          "#c3c3d5",
          "#d0d0d7",

          "#f9f7eb",
          "#ededf7",
          "#ffffff",
          "#ffffff",
          "#eee9d3",
          "#d0d0d7",
          "#c3c3d5",
          "#dee2da",

          "#fffae5",
          "#f9f7eb",
          "#ededf7",
          "#ffffff",
          "#d0d0d7",
          "#c3c3d5",
          "#e2dfcf",
          "#dee2da",

          "#f9f7eb",
          "#fffae5",
          "#ededf7",
          "#ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": -1,
        "hexSize": 42,
        "rotation": 40.9,
        "fundamental": 440,
        "reference_degree": 39,
        "center_degree": 0,
      },
      {
        "name": "12-Harmonic Partials (fundamental = A)",
        "description":
          "12-tone 19-Limit Rational Intonation (JI) scale. Derived from the harmonic partial row, it is limited to partials 12°-25° over A, skipping 23°.",
        "short_description": "12-HS_A13-26no23",
        "scale_import": scale_12_hs,
        "scale": parseScale(scale_12_hs).scale,
        "equivSteps": 12,
        "note_names": ["E", "E", "F", "G", "G", "A", "A", "B", "C", "C", "D", "D"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffa5a5",
          "#fef5be",
          "#e6d7fe",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#d6f7ff",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 5,
        "center_degree": 5,
      },
      {
        "name": "12-Subharmonic (Elsie Hamilton) 19-Limit",
        "description":
          "12-tone 19-Limit Rational Intonation (JI) scale. Derived from the subharmonic partial row, it is limited to partials u12-u25 under F-comma-up, skipping 23°.",
        "short_description": "12-HamiltonModes",
        "scale_import": scale_12_hamilton,
        "scale": parseScale(scale_12_hamilton).scale,
        "equivSteps": 12,
        "note_names": ["B", "C", "C", "D", "D", "E", "F", "F", "G", "G", "A", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9393",
          "#b6e8a1",
          "#eecbc9",
          "#beb58f",
          "#d4eff2",
          "#c7c1a1",
          "#cdcdc9",
          "#e9e1b4",
          "#beb58f",
          "#eecbc9",
          "#e2d3f1",
          "#e7e1c8"
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 352,
        "reference_degree": 7,
        "center_degree": 7,
      },
      {
        "name": "12-Subharmonic (Elsie Hamilton) E-A-D 13-limit",
        "description":
          "12-tone 13-Limit Rational Intonation (JI) scale. Derived from the subharmonic partial row, it is limited to partials u8-u15 under F-comma-up, as well as subharmonics of E (A, D, F, B).",
        "short_description": "12-HamiltonModes",
        "scale": [
          "12/11",
          "8/7",
          "6/5",
          "5/4",
          "4/3",
          "45/32",
          "3/2",
          "8/5",
          "12/7",
          "24/13",
          "15/8",
          "2/1",
        ],
        "equivSteps": 12,
        "note_names": ["B", "C", "C", "D", "*nD", "E", "*nE", "F", "G", "G", "A", "*nA"],
        "note_colors": [
          "#ff9494",
          "#b6e8a1",
          "#eecbc9",
          "#beb58f",
          "#ffffff",
          "#c7c1a1",
          "#ffffff",
          "#e9e1b4",
          "#beb58f",
          "#eecbc9",
          "#e2d3f1",
          "#ffffff"
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 440,
        "reference_degree": 11,
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "center_degree": 6,
      },
      {
        "name": "12-Septimal-Quintal",
        "description":
          "12-tone 7-Limit Rational Intonation scale, derived from harmonic partial row intervals up to a prime limit of 7. The 7° partial over C produces a harmonic partial row 9th chord over fundamental C: 4:5:6:7:9 and the 5:7 diminished fifth above C produces a more consonant interval than the 5-Limit ratio 32:45. Also, in this scale the 3/4-tone melodic step 25:27, found in the 5-Limit JI scale between 5/3 (A) and 9/5 (B), is replaced with the familiar small semitone 20:21.",
        "short_description": "12-JI-7L",
        "scale_import": scale_12_ji_7l,
        "scale": parseScale(scale_12_ji_7l).scale,
        "equivSteps": 12,
        "note_names": ["C", "D", "D", "E", "E", "F", "G", "G", "A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#ffffff",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#ece6df",
          "#ffffff",
          "#dee2da",
          "#fffae5",
          "#ffe5e5",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 260.740741,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "12-Septimal Blues",
        "description":
          "12-tone Septimal-Tertial Rational Intonation Blues scale, derived from harmonic partial row intervals limited to the prime subgroup of 2, 3, and 7, combined with 5-Limit triads on F, C and G.",
        "short_description": "12-JI-7L-blues",
        "scale_import": scale_12_ji_blues_7l,
        "scale": parseScale(scale_12_ji_blues_7l).scale,
        "equivSteps": 12,
        "note_names": ["C", "D", "D", "E", "E", "F", "G", "G", "A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffa2a2",
          "#f8c9c9",
          "#ffffff",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#f8c9c9",
          "#ffffff",
          "#ffe5e5",
          "#fffae5",
          "#ffe5e5",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 260.740741,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "12-JI (3,7,11)",
        "description":
          "12-tone Undecimal-Septimal-Tertial Rational Intonation scale, derived from harmonic partial row intervals limited to the prime subgroup combining 2, 3, 7, and 11. The usual JI intervals based on 5 are not included, and the typical consonant chord is 6:7:8:9:11:12.",
        "short_description": "12-JI-3.7.11",
        "scale_import": scale_12_ji_7_11,
        "scale": parseScale(scale_12_ji_7_11).scale,
        "equivSteps": 12,
        "note_names": ["C", "C", "D", "E", "F", "F", "F", "G", "A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffa8a8",
          "#dfffd6",
          "#ffffff",
          "#ffe5e5",
          "#ffe5e5",
          "#ffffff",
          "#dfffd6",
          "#ffffff",
          "#e9ecc1",
          "#ffffff",
          "#ffe5e5",
          "#dfffd6",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
      },
      {
        "name": "12-JI (3,5,13)",
        "description":
          "12-tone Tridecimal-Quintal Rational Intonation scale, derived from harmonic partial row intervals limited to the prime subgroup combining 2, 3, 5, and 13. The typical consonant chord is 10:12:13:15(:16).",
        "short_description": "12-JI-3.5.13",
        "scale_import": scale_12_ji_5_13,
        "scale": parseScale(scale_12_ji_5_13).scale,
        "equivSteps": 12,
        "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffd0d0",
          "#e6d7fe",
          "#ffffff",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#e6e0cb",
          "#ffffff",
          "#e6d7fe",
          "#fffae5",
          "#dbb3ff",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 260.740741,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "12-Sabat I JI Well Temperament",
        "description":
          "12-tone Rational Intonation Well Temperament, derived from harmonic partial row intervals limited to the prime subgroup of 2, 3, 17, 19 and 577. The seven diatonic notes are tuned Pythagorean, and the five whole tones are divided evenly using the higher primes. Conceived as an inversion of Vallotti's temperament with six pure fifths and six fifths narrowed by 1/6-Comma. Allows instruments at 415 Hz to play in 1/6-Comma meantone together with 440 Hz instruments tuned in JI.",
        "short_description": "12-WT-SabatI",
        "scale_import": scale_12_ji_sabat_I,
        "scale": parseScale(scale_12_ji_sabat_I).scale,
        "equivSteps": 12,
        "note_names": ["C", "C", "D", "E", "E", "F", "F", "G", "G A", "A", "B", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffdbdb",
          "#cfcfcf",
          "#ffffff",
          "#c6c6c6",
          "#ffffff",
          "#ffffff",
          "#ceeef6",
          "#ffffff",
          "#c6c6c6",
          "#ffffff",
          "#d6f7ff",
          "#ffffff"
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
      },
      {
        "name": "12-Sabat II JI Well Temperament",
        "description":
          "12-tone Rational Intonation Well Temperament, derived from harmonic partial row intervals limited to the prime subgroup of 2, 3, 5, and 17, 19. Seven diatonic notes and F are tuned Pythagorean, allowing the historical Persian Arabic schisma tunings to be applied. A and D are added as major thirds, and the two remaining tones are divided evenly using 16:17.",
        "short_description": "12-WT-SabatII",
        "scale_import": scale_12_ji_sabat_II,
        "scale": parseScale(scale_12_ji_sabat_II).scale,
        "equivSteps": 12,
        "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "G", "A", "A", "B"],
        "key_labels": "note_names",
        "note_colors": [
          "#ffdbdb",
          "#c7c1a1",
          "#ffffff",
          "#c6c6c6",
          "#ffffff",
          "#ffffff",
          "#dee2da",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#e6e0cb",
          "#ffffff"
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
      },
    ],
  },
  {
    "name": "Arabic and Persian Theoretical Systems",
    "settings": [
      {
        "name": "22-Farabi",
        "description":
          '22-tone 17-Limit Rational Intonation gamut, proposed by Abu Nasr Farabi (872-950), also known as al-Farabi, in his book Kitab al-Musiqa al-Kabir ("The Great Book of Music"). This maps a theoretical fretting of the oud, obtaining several commonly used divisions of the tetrachord. The gamut combines divisions (intervals) derived by combining primes 2, 3, 11, and 17. The chain of 9 subharmonic perfect fifths tuned below the fundamental also ends in four pitches one schisma lower than common 5-Limit ratios (45/32, 15/8, 5/4, 5/3). Thanks to Idin Samimi Mofakham for translation, analysis, and documentation.',
        "short_description": "22-Farabi",
        "scale_import": scale_22_ji_17l,
        "scale": parseScale(scale_22_ji_17l).scale,
        "equivSteps": 22,
        "note_names": [
          "C",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "C",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#d0d0d7",
          "#c3c3e9",
          "#cee3e2",
          "#ffffff",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffffff",
          "#fffae5",
          "#c3c3e9",
          "#cee3e2",
          "#ffffff",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#fffae5",
          "#c3c3e9",
          "#cee3e2",
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 17,
        "center_degree": 0,
      },
      {
        "name": "22-Sabat-Maqam",
        "description":
          "22-tone 59-Limit Rational Intonation gamut, proposed by Marc Sabat based on Abu Nasr Farabi (872-950), also known as al-Farabi. This maps a theoretical fretting of the oud, obtaining several commonly used divisions of the tetrachord. The gamut combines divisions (intervals) derived by combining primes 2, 3, and 59, which subharmonically divides the Pythagorean minor third 54:59:64. The chain of 11 subharmonic perfect fifths tuned below the fundamental also ends in six pitches one schisma lower than common 5-Limit ratios (45/32, 15/8, 5/4, 5/3).",
        "short_description": "22-Sabat-Maqam",
        "scale_import": scale_22_ji_59l,
        "scale": parseScale(scale_22_ji_59l).scale,
        "equivSteps": 22,
        "note_names": [
          "C",
          "C",
          "C",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "*nB",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dfffd6",
          "#fffae5",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dfffd6",
          "#fffae5",
          "#ffffff",
          "#ffffff",
          "#dfffd6",
          "#fffae5",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dfffd6",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dfffd6",
          "#fffae5",
          "#ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 17,
        "center_degree": 0,
      },
      {
        "name": "17-Ibn Sina",
        "description":
          "17-tone 13-Limit Rational Intonation gamut, proposed by Ibn Sina (980-1037), also known as Avicenna, in the encyclopaedia Kitab al-Shifa, as a fretting of the oud as used in his time. The gamut combines divisions (intervals) derived by combining primes 2, 3, 7, and 13. Thanks to Idin Samimi Mofakham for translation, analysis, and documentation.",
        "short_description": "17-JI-13lIbnSina",
        "scale_import": scale_17_ji_13l,
        "scale": parseScale(scale_17_ji_13l).scale,
        "equivSteps": 17,
        "note_names": [
          "C",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "B",
          "C",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffa3a3",
          "#ead9fa",
          "#e6d7fe",
          "#ffffff",
          "#d0d0d7",
          "#e6d7fe",
          "#ffffff",
          "#ffffff",
          "#ebd0e0",
          "#e6d7fe",
          "#ffffff",
          "#d0d0d7",
          "#e6d7fe",
          "#ffffff",
          "#d0d0d7",
          "#ebd0e0",
          "#e6d7fe",
        ],
        "key_colors_mode": "manual",
        "rSteps": 3,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 13,
        "center_degree": 0,
      },
      {
        "name": "17-Ormavi",
        "description":
          "17-tone 3-Limit Rational Intonation gamut, proposed by Safiaddin Ormavi (1216-1294), generated from 12 perfect fifths descending and 4 ascending plus the fundamental, producing 17 notes per octave derived from harmonic partial row intervals up to a prime limit of 3 (Pythagorean tuning). Thanks to Idin Samimi Mofakham for translation, analysis, and documentation.",
        "short_description": "17-JI-3L_Ormavi",
        "scale_import": scale_17_ji_3l,
        "scale": parseScale(scale_17_ji_3l).scale,
        "equivSteps": 17,
        "note_names": [
          "C",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "B",
          "B",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffcdcd",
          "#d0d0d7",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#fffae5",
          "#ffffff",
          "#ffffff",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#fffae5",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 3,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 13,
        "center_degree": 0,
      },
    ],
  },
  {
    "name": "Indian Theoretical Systems",
    "settings": [
      {
        "name": "22-Sruti (Sambamurthy/Daniélou)",
        "description":
          "22-tone Quintal Rational Intonation Indian śruti gamut, according to Sambamurthy/Daniélou, consisting of 22 notes per octave derived from harmonic partial row intervals up to a prime limit of 5. Derived by schisma-alteration from a 22-tone 3-Limit scale generated from 11 perfect fifths ascending and 10 descending plus the fundamental. Notated with Indian syllable names.",
        "short_description": "22-JI-5L_Srutis",
        "scale_import": scale_22_ji_5l,
        "scale": parseScale(scale_22_ji_5l).scale,
        "equivSteps": 22,
        "note_names": [
          " Sa ",
          " ReL- ",
          " ReL+ ",
          " Re- ",
          " Re ",
          " GaL ",
          " Ga♭ ",
          " Ga ",
          " Ga+ ",
          " Ma ",
          " Ma+ ",
          " MaL- ",
          " MaL+ ",
          " Pa ",
          " DhaL ",
          " Dha♭ ",
          " Dha ",
          " Dha+ ",
          " NiL ",
          " Ni♭ ",
          " Ni ",
          " Ni+ ",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#ffffff",
          "#dee2da",
          "#fffae5",
          "#dee2da",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 17,
        "center_degree": 0,
      }
    ],
  },
  {
    "name": "Harmonics and Subharmonics",
    "settings": [
      {
        "name": "HS 12°-48°: harmonic partial row from 12° to 48°",
        "description":
          "A two octave cycle comprising the harmonic partial row from 12° to 48°. 12° is mapped to MIDI Note 60 (Middle C), and tuned to 240 Hz, giving 1° = 20 Hz. The entire series may be transposed to any fundamental by changing the Reference Frequency, which (in this case) will set the pitch-class 3°. The first octave of the scale (12° to 24°) has 12 pitch-classes, and the second (24° to 48°) has 24, mapping onto 3 octaves of a conventional keyboard. Note that partials below 12° may also be played by taking lower even-numbered scale degrees.",
        "short_description": "36-HS_12to24",
        "scale_import": scale_36_hs_12to48,
        "scale": parseScale(scale_36_hs_12to48).scale,
        "equivSteps": 36,
        "note_names": [
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "32",
          "33",
          "34",
          "35",
          "36",
          "37",
          "38",
          "39",
          "40",
          "41",
          "42",
          "43",
          "44",
          "45",
          "46",
          "47",
          "48",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9898",
          "#e6d7fe",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#d6f7ff",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
          "#95c69b",
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#ffffff",
          "#ffe5e5",
          "#8aafff",
          "#fffae5",
          "#68f3ec",
          "#ffffff",
          "#dfffd6",
          "#cfcfcf",
          "#ffcba8",
          "#ffffff",
          "#cee3e2",
          "#d6f7ff",
          "#e6d7fe",
          "#fffae5",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfffd6",
          "#fffae5",
          "#95c69b",
          "#ffb8da"
        ],
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 240,
        "reference_degree": 0,
        "center_degree": 0,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "HS 12°-48° (Odd Partial Notation)",
        "description":
          "A two octave cycle comprising the harmonic partial row from 12° to 48°. 12° is mapped to MIDI Note 60 (Middle C), and tuned to 240 Hz, giving 1° = 20 Hz. The entire series may be transposed to any fundamental by changing the Reference Frequency, which (in this case) will set the pitch-class 3°. The first octave of the scale (12° to 24°) has 12 pitch-classes, and the second (24° to 48°) has 24, mapping onto 3 octaves of a conventional keyboard. The tones are notated as Odd Partial Pitch Classes.",
        "short_description": "36-HS_12to24",
        "scale_import": scale_36_hs_12to48,
        "scale": parseScale(scale_36_hs_12to48).scale,
        "equivSteps": 36,
        "note_names": [
          "3",
          "13",
          "7",
          "15",
          "1",
          "17",
          "9",
          "19",
          "5",
          "21",
          "11",
          "23",
          "12",
          "25",
          "13",
          "27",
          "7",
          "29",
          "15",
          "31",
          "1",
          "33",
          "17",
          "35",
          "9",
          "37",
          "19",
          "39",
          "5",
          "41",
          "21",
          "43",
          "11",
          "45",
          "23",
          "47",
          "3",
        ],
        "key_labels": "note_names",
         "note_colors": [
          "#ff9898",
          "#e6d7fe",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#d6f7ff",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
          "#95c69b",
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#ffffff",
          "#ffe5e5",
          "#8aafff",
          "#fffae5",
          "#68f3ec",
          "#ffffff",
          "#dfffd6",
          "#cfcfcf",
          "#ffcba8",
          "#ffffff",
          "#cee3e2",
          "#d6f7ff",
          "#e6d7fe",
          "#fffae5",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfffd6",
          "#fffae5",
          "#95c69b",
          "#ffb8da"
        ],
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 240,
        "reference_degree": 0,
        "center_degree": 0,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "HS_SH 12-48: Harmonics/Subharmonics combined",
        "description":
          'Harmonic and Subharmonic partial rows from 12° to 48° mapped onto a four octave cycle. 12 is mapped to MIDI Note 60 (Middle C), and tuned to 240 Hz. The "subharmonic" row is a mirroring, with intervals taken downward from a common pitch. Subharmonic chords do not exhibit the same psychoacoustic fusion and combination tone reinforcement as harmonic chords, but they produce melodically related sets that harmonise with a sustained higher pitch (e.g., in counterpoint). Some JI composers (i.e., Elsie Hamilton, Harry Partch, Ben Johnston) have worked extensively with symmetrically structured otonal / utonal harmonies.',
        "short_description": "72-HSS_12to48",
        "scale_import": scale_72_hss_12to48,
        "scale": parseScale(scale_72_hss_12to48).scale,
        "equivSteps": 72,
        "note_names": [
          "12",
          "13°",
          "14°",
          "15°",
          "16°",
          "17°",
          "18°",
          "19°",
          "20°",
          "21°",
          "22°",
          "23°",
          "24°",
          "25°",
          "26°",
          "27°",
          "28°",
          "29°",
          "30°",
          "31°",
          "32°",
          "33°",
          "34°",
          "35°",
          "36°",
          "37°",
          "38°",
          "39°",
          "40°",
          "41°",
          "42°",
          "43°",
          "44°",
          "45°",
          "46°",
          "47°",
          "48",
          "47",
          "46",
          "45",
          "44",
          "43",
          "42",
          "41",
          "40",
          "39",
          "38",
          "37",
          "36",
          "35",
          "34",
          "33",
          "32",
          "31",
          "30",
          "29",
          "28",
          "27",
          "26",
          "25",
          "24",
          "23",
          "22",
          "21",
          "20",
          "19",
          "18",
          "17",
          "16",
          "15",
          "14",
          "13",
          "12",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9f9f",
          "#e6d7fe",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#d6f7ff",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
          "#95c69b",
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#ffffff",
          "#ffe5e5",
          "#8aafff",
          "#fffae5",
          "#68f3ec",
          "#ffffff",
          "#dfffd6",
          "#cfcfcf",
          "#ffcba8",
          "#ffffff",
          "#cee3e2",
          "#d6f7ff",
          "#e6d7fe",
          "#fffae5",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfffd6",
          "#fffae5",
          "#95c69b",
          "#ffb8da",
          "#ffffff",
          "#f4b0d1",
          "#8fbd94",
          "#f6f2db",
          "#9fe48c",
          "#c19f70",
          "#ecc5c7",
          "#ec9684",
          "#f6f2db",
          "#decef5",
          "#ceeef6",
          "#c6dad9",
          "#ffffff",
          "#eecbc9",
          "#c6c6c6",
          "#9fe48c",
          "#ffffff",
          "#65e7e0",
          "#f6f2db",
          "#84a8f4",
          "#ecc5c7",
          "#ffffff",
          "#decef5",
          "#efe9d2",
          "#ffffff",
          "#8fbd94",
          "#9fe48c",
          "#ecc5c7",
          "#f6f2db",
          "#ceeef6",
          "#ffffff",
          "#c6c6c6",
          "#ffffff",
          "#f6f2db",
          "#ecc5c7",
          "#decef5"
        ],
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 240,
        "reference_degree": 0,
        "center_degree": 0,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "SH_HS 12-48: Subharmonics/Harmonics combined",
        "description":
          "Subharmonic and Harmonic partial rows from 12° to 48° mapped onto a four octave cycle. In this scale, the subharmonic row is placed below the harmonic one, so the small microtonal intervals lie in the centre of the keyboard range.",
        "short_description": "72-SHS_12to48",
        "scale_import": scale_72_shs_12to48,
        "scale": parseScale(scale_72_shs_12to48).scale,
        "equivSteps": 72,
        "note_names": [
          "48",
          "47",
          "46",
          "45",
          "44",
          "43",
          "42",
          "41",
          "40",
          "39",
          "38",
          "37",
          "36",
          "35",
          "34",
          "33",
          "32",
          "31",
          "30",
          "29",
          "28",
          "27",
          "26",
          "25",
          "24",
          "23",
          "22",
          "21",
          "20",
          "19",
          "18",
          "17",
          "16",
          "15",
          "14",
          "13",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "32",
          "33",
          "34",
          "35",
          "36",
          "37",
          "38",
          "39",
          "40",
          "41",
          "42",
          "43",
          "44",
          "45",
          "46",
          "47",
          "48",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9f9f",
          "#f4b0d1",
          "#8fbd94",
          "#f6f2db",
          "#9fe48c",
          "#c19f70",
          "#ecc5c7",
          "#ec9684",
          "#f6f2db",
          "#decef5",
          "#ceeef6",
          "#c6dad9",
          "#ffffff",
          "#eecbc9",
          "#c6c6c6",
          "#9fe48c",
          "#ffffff",
          "#65e7e0",
          "#f6f2db",
          "#84a8f4",
          "#ecc5c7",
          "#ffffff",
          "#decef5",
          "#efe9d2",
          "#ffffff",
          "#8fbd94",
          "#9fe48c",
          "#ecc5c7",
          "#f6f2db",
          "#ceeef6",
          "#ffffff",
          "#c6c6c6",
          "#ffffff",
          "#f6f2db",
          "#ecc5c7",
          "#decef5",
          "#ffffff",
          "#e6d7fe",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#cfcfcf",
          "#ffffff",
          "#d6f7ff",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
          "#95c69b",
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#ffffff",
          "#ffe5e5",
          "#8aafff",
          "#fffae5",
          "#68f3ec",
          "#ffffff",
          "#dfffd6",
          "#cfcfcf",
          "#ffcba8",
          "#ffffff",
          "#cee3e2",
          "#d6f7ff",
          "#e6d7fe",
          "#fffae5",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfffd6",
          "#fffae5",
          "#95c69b",
          "#ffb8da"
        ],
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 240,
        "reference_degree": 0,
        "center_degree": 0,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "19-tone partial sequence (32°-52°) repeating at 3/2",
        "description":
          "A cycle of harmonic partials (32° 33°) 34° to 51° (52°), repeating at the perfect fifth over changing fundamentals. Partial 48° is reinterpreted as 32° (and 51° = 34°); the fundamental shifts up a perfect fifth. Matching partial numbers produce perfect fifths instead of octaves. Useful for investigating possible chords of higher partials embedded within a perfect fifth, for example 6:7:8:9, 8:9:11:12, 10:12:13:15, and others. The 48° of the central transposition of the scale is set to 440 Hz.",
        "short_description": "19-HS_34to52",
        "scale_import": scale_19_hs_34to52,
        "scale": parseScale(scale_19_hs_34to52).scale,
        "equivSteps": 19,
        "note_names": [
          "51|34",
          "52|",
          "|35",
          "36",
          "37",
          "38",
          "39",
          "40",
          "41",
          "42",
          "43",
          "44",
          "45",
          "46",
          "47",
          "48|32",
          "49|",
          "|33",
          "50|",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff7070",
          "#e6d7fe",
          "#ffcba8",
          "#ffffff",
          "#cee3e2",
          "#d6f7ff",
          "#e6d7fe",
          "#fffae5",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfffd6",
          "#fffae5",
          "#95c69b",
          "#ffb8da",
          "#ffffff",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be"
        ],
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "rSteps": 5,
        "drSteps": 1,
        "hexSize": 36,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 15,
        "center_degree": 0,
      },
      {
        "name": "19-tone partial sequence (32°-52°) (Odd Partial Notation)",
        "description":
          "A cycle of harmonic partials (32° 33°) 34° to 51° (52°), repeating at the perfect fifth over changing fundamentals. Partial 48° is reinterpreted as 32° (and 51° = 34°); the fundamental shifts up a perfect fifth. Matching partial numbers produce perfect fifths instead of octaves. Useful for investigating possible chords of higher partials embedded within a perfect fifth, for example 6:7:8:9, 8:9:11:12, 10:12:13:15, and others. The 48° of the central transposition of the scale is set to 440 Hz.",
        "short_description": "19-HS_34to52-Odd",
        "scale_import": scale_19_hs_34to52,
        "scale": parseScale(scale_19_hs_34to52).scale,
        "equivSteps": 19,
        "note_names": [
          "51|17",
          "13|",
          "|35",
          "9",
          "37",
          "19",
          "39",
          "5",
          "41",
          "21",
          "43",
          "11",
          "45",
          "23",
          "47",
          "3|1",
          "49|",
          "|33",
          "25|",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff7070",
          "#e6d7fe",
          "#ffcba8",
          "#ffffff",
          "#cee3e2",
          "#d6f7ff",
          "#e6d7fe",
          "#fffae5",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfffd6",
          "#fffae5",
          "#95c69b",
          "#ffb8da",
          "#ffffff",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be"
        ],
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "rSteps": 4,
        "drSteps": 3,
        "hexSize": 36,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 15,
        "center_degree": 0,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "HS 53°-106°: harmonic partial row from 53° to 106°",
        "description":
          "A 53-tone one octave cycle comprising the harmonic partial row from 53° to 106°. 54° (Degree 1) is tuned to A 220 Hz, so the fundamental pitch-class (1°, 2°, 4°, 8°, 16°, etc.) is Pythagorean C. The central degree is 11 (1°). The entire series may be transposed to any fundamental by changing the Reference Frequency and Degree.",
        "short_description": "53-HS_53to106",
        "scale_import": scale_53_hs_53to106,
        "scale": parseScale(scale_53_hs_53to106).scale,
        "equivSteps": 53,
        "note_names": [
          "53°",
          "27°",
          "55°",
          "7",
          "57",
          "29",
          "59",
          "15",
          "61",
          "31",
          "63",
          "1",
          "65",
          "33",
          "67",
          "17",
          "69",
          "35",
          "71",
          "9",
          "73",
          "37",
          "75",
          "19",
          "77",
          "39",
          "79",
          "5",
          "81",
          "41",
          "83",
          "21",
          "85",
          "43",
          "87",
          "11",
          "89",
          "45",
          "91",
          "23",
          "93",
          "47",
          "95",
          "3",
          "97",
          "49",
          "99",
          "25",
          "101",
          "51",
          "103",
          "13",
          "105",
          "53",
        ],
        "key_labels": "note_names",
        "note_colors": [],
        "key_colors_mode": "manual",
        "note_colors": [
          "#ededed",
          "#ffffff",
          "#ddfe95",
          "#ffe5e5",
          "#d6f7ff",
          "#b6ece3",
          "#e5adff",
          "#fffae5",
          "#ededed",
          "#68f3ec",
          "#ffe5e5",
          "#ffffff",
          "#e9d7d3",
          "#dfffd6",
          "#ededed",
          "#cfcfcf",
          "#95c69b",
          "#ffcba8",
          "#ededed",
          "#ffffff",
          "#ededed",
          "#cee3e2",
          "#fef5be",
          "#d6f7ff",
          "#e9ecc1",
          "#e6d7fe",
          "#ededed",
          "#fffae5",
          "#ffffff",
          "#d39e92",
          "#ededed",
          "#ffe5e5",
          "#eceae4",
          "#dee2da",
          "#8aafff",
          "#dfffd6",
          "#ededed",
          "#fffae5",
          "#ebd0e0",
          "#95c69b",
          "#68f3ec",
          "#ffb8da",
          "#e5fff9",
          "#ffffff",
          "#ededed",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#ededed",
          "#cfcfcf",
          "#ededed",
          "#e6d7fe",
          "#ffcba8",
          "#ededed",
        ],
        "rSteps": 9,
        "drSteps": 4,
        "hexSize": 32,
        "rotation": -16.102113751,
        "fundamental": 220,
        "reference_degree": 1,
        "center_degree": 11,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "HS 55°-110°: harmonic partial row from 55° to 110°",
        "description":
          "A 55-tone one octave cycle comprising the harmonic partial row from 55° to 110°. 27° (Degree 53) is tuned to A 440 Hz, so the fundamental pitch-class (1°, 2°, 4°, 8°, 16°, etc.) is Pythagorean C. The Central Degree is 9 (1°). The entire series may be transposed to any fundamental by changing the Reference Frequency and Degree.",
        "short_description": "55-HS_55to110",
        "scale_import": scale_55_hs_55to110,
        "scale": parseScale(scale_55_hs_55to110).scale,
        "equivSteps": 55,
        "note_names": [
          "55°",
          "7",
          "57",
          "29",
          "59",
          "15",
          "61",
          "31",
          "63",
          "1",
          "65",
          "33",
          "67",
          "17",
          "69",
          "35",
          "71",
          "9",
          "73",
          "37",
          "75",
          "19",
          "77",
          "39",
          "79",
          "5",
          "81",
          "41",
          "83",
          "21",
          "85",
          "43",
          "87",
          "11",
          "89",
          "45",
          "91",
          "23",
          "93",
          "47",
          "95",
          "3",
          "97",
          "49",
          "99",
          "25",
          "101",
          "51",
          "103",
          "13",
          "105",
          "53",
          "107",
          "27",
          "109",
          "55",
        ],
        "key_labels": "note_names",
        "note_colors": [],
        "key_colors_mode": "manual",
        "note_colors": [
          "#ddfe95",
          "#ffe5e5",
          "#d6f7ff",
          "#b6ece3",
          "#e5adff",
          "#fffae5",
          "#ededed",
          "#68f3ec",
          "#ffe5e5",
          "#ffffff",
          "#e9d7d3",
          "#dfffd6",
          "#ededed",
          "#cfcfcf",
          "#95c69b",
          "#ffcba8",
          "#ededed",
          "#ffffff",
          "#ededed",
          "#cee3e2",
          "#fef5be",
          "#d6f7ff",
          "#e9ecc1",
          "#e6d7fe",
          "#ededed",
          "#fffae5",
          "#ffffff",
          "#d39e92",
          "#ededed",
          "#ffe5e5",
          "#eceae4",
          "#dee2da",
          "#8aafff",
          "#dfffd6",
          "#ededed",
          "#fffae5",
          "#ebd0e0",
          "#95c69b",
          "#68f3ec",
          "#ffb8da",
          "#e5fff9",
          "#ffffff",
          "#ededed",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#ededed",
          "#cfcfcf",
          "#ededed",
          "#e6d7fe",
          "#ffcba8",
          "#ededed",
          "#ededed",
          "#ffffff",
          "#ededed",
          "#ddfe95",
        ],
        "rSteps": 8,
        "drSteps": 5,
        "hexSize": 32,
        "rotation": -8.2,
        "fundamental": 440,
        "reference_degree": 53,
        "center_degree": 9,
        "lumatone_anchor_note": 5,
        "lumatone_anchor_channel": 2
      },
      {
        "name": "55-Critical Band",
        "description":
          '55-tone 19-Limit Rational Intonation scale, based on James Tenney’s "Critical Band". The tones fan out geometrically around A 440, suggesting a sequence of fundamentals rising by octaves (127:128:129, 63:64:65, 31:32:33, 15:16:17, 7:8:9, 3:4:5, 1:2:3). As the frequency band widens, the chords become increasingly harmonic. The space between G-sharp and A-sharp is filled with small steps, the remaining pitch classes make a chromatic harmonic scale.',
        "short_description": "55-Critical Band",
        "scale_import": scale_55_criticalband,
        "scale": parseScale(scale_55_criticalband).scale,
        "equivSteps": 55,
        "note_names": [
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "127°",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffdbdb",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 0,
        "center_degree": 0,
      },
    ],
  },
  {
    "name": "Odd Partial Pitch Class Sets",
    "settings": [
      {
        "name": "14-(3,5) < 256°",
        "description":
          "14-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3 and 5. Odd harmonics produce distinct pitch classes, and mark their lowest, i.e., most consonant, position from the generating fundamental. JI intervals, chords, gamuts, melodies are all sets of odd partials. By limiting component primes and maximum partial, harmonic radius is minimised, providing greater perceived harmonicity.",
        "short_description": "OddPartials(3,5)",
        "scale_import": scale_14_hs_odd_3_5,
        "scale": parseScale(scale_14_hs_odd_3_5).scale,
        "equivSteps": 14,
        "note_names": [
          "1",
          "135",
          "9",
          "75",
          "5",
          "81",
          "45",
          "3",
          "25",
          "27",
          "225",
          "15",
          "243",
          "125",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffdbdb",
          "#fffae5",
          "#ffffff",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#fffae5",
          "#ffffff",
          "#fef5be",
          "#ffffff",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#ffef8a",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 9,
        "center_degree": 0,
      },
      {
        "name": "12-(3,7) < 256°",
        "description":
          "12-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3 and 7.",
        "short_description": "OddPartials(3,7)",
        "scale_import": scale_12_hs_odd_3_7,
        "scale": parseScale(scale_12_hs_odd_3_7).scale,
        "equivSteps": 12,
        "note_names": [
          "1",
          "9",
          "147",
          "81",
          "21",
          "189",
          "3",
          "49",
          "27",
          "7",
          "243",
          "63",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffa2a2",
          "#ffffff",
          "#f8c9c9",
          "#ffffff",
          "#ffe5e5",
          "#ffe5e5",
          "#ffffff",
          "#f8c9c9",
          "#ffffff",
          "#ffe5e5",
          "#ffffff",
          "#ffe5e5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 8,
        "center_degree": 0,
      },
      {
        "name": "18-(3,7,11) < 256°",
        "description":
          "18-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3, 7, and 11. By including 3 primes in addition to 2 (which is treated as an equivalence relation in all of these sets), the harmonic dimensionality is increased. It is possible, for example, to move between consonant four-note chords featuring different primes, connected by common tones. These relationships may be more easily imagined with the help of the HEJI notation (see the next scale).",
        "short_description": "OddPart(3,7,11)",
        "scale_import": scale_18_hs_odd_3_7_11,
        "scale": parseScale(scale_18_hs_odd_3_7_11).scale,
        "equivSteps": 18,
        "note_names": [
          "1",
          "33",
          "9",
          "147",
          "77",
          "81",
          "21",
          "11",
          "189",
          "3",
          "49",
          "99",
          "27",
          "7",
          "231",
          "121",
          "243",
          "63",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffa2a2",
          "#dfffd6",
          "#ffffff",
          "#f8c9c9",
          "#e9ecc1",
          "#ffffff",
          "#ffe5e5",
          "#dfffd6",
          "#ffe5e5",
          "#ffffff",
          "#f8c9c9",
          "#dfffd6",
          "#ffffff",
          "#ffe5e5",
          "#e9ecc1",
          "#c3ffad",
          "#ffffff",
          "#ffe5e5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 12,
        "center_degree": 0,
      },
      {
        "name": "20-(3,5,13) < 256°",
        "description":
          "20-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3, 5, and 13.",
        "short_description": "OddPart(3,5,13)",
        "scale_import": scale_20_hs_odd_3_5_13,
        "scale": parseScale(scale_20_hs_odd_3_5_13).scale,
        "equivSteps": 20,
        "note_names": [
          "1",
          "65",
          "135",
          "9",
          "75",
          "39",
          "5",
          "81",
          "169",
          "45",
          "3",
          "195",
          "25",
          "13",
          "27",
          "225",
          "117",
          "15",
          "243",
          "125",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffbcbc",
          "#e9d7d3",
          "#fffae5",
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#dbb3ff",
          "#fffae5",
          "#ffffff",
          "#e9d7d3",
          "#fef5be",
          "#e6d7fe",
          "#ffffff",
          "#fef5be",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#ffef8a",
        ],
        "key_colors_mode": "manual",
        "rSteps": 3,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 14,
        "center_degree": 0,
      },
      {
        "name": "40-(13-Limit) < 256°",
        "description":
          "40-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 13. This set combines all of the preceding pitches, and also contains new pitch classes produced by primes interacting with each other (i.e. 5° and 7° combine to produce 35°). This allows chords in which higher primes meet to coexist with the simpler chords featuring only one higher prime.",
        "short_description": "OddPartials(13L)",
        "scale_import": scale_40_hs_odd_13l,
        "scale": parseScale(scale_40_hs_odd_13l).scale,
        "equivSteps": 40,
        "note_names": [
          "1",
          "65",
          "33",
          "135",
          "35",
          "143",
          "9",
          "147",
          "75",
          "77",
          "39",
          "5",
          "81",
          "165",
          "21",
          "169",
          "175",
          "11",
          "45",
          "91",
          "189",
          "3",
          "195",
          "49",
          "99",
          "25",
          "13",
          "105",
          "27",
          "55",
          "7",
          "225",
          "231",
          "117",
          "15",
          "121",
          "243",
          "245",
          "125",
          "63",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9696",
          "#e9d7d3",
          "#dfffd6",
          "#fffae5",
          "#ffcba8",
          "#90f9cd",
          "#ffffff",
          "#f8c9c9",
          "#fef5be",
          "#e9ecc1",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#ddfe95",
          "#ffe5e5",
          "#dbb3ff",
          "#ffd270",
          "#dfffd6",
          "#fffae5",
          "#ebd0e0",
          "#ffe5e5",
          "#ffffff",
          "#e9d7d3",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#e6d7fe",
          "#ffcba8",
          "#ffffff",
          "#ddfe95",
          "#ffe5e5",
          "#fef5be",
          "#e9ecc1",
          "#e6d7fe",
          "#fffae5",
          "#c3ffad",
          "#ffffff",
          "#ffb59a",
          "#ffef8a",
          "#ffe5e5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 6,
        "drSteps": 5,
        "hexSize": 41,
        "rotation": -21.05,
        "fundamental": 440,
        "reference_degree": 28,
        "center_degree": 0,
      },
      {
        "name": "55-(19-Limit) < 256°",
        "description":
          "55-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 19. This set combines all of the preceding pitches, and adds primes 17° and 19° along with their multiples. The limit is chosen because it is the highest prime that allows a complete 13-Limit harmony to be constructed within the partials up to 256, and because the addition of 17° and 19° produce a more even scale. The resulting harmonic space subset is therefore maximally compact while providing the most consonant modulations in seven dimensions (3°, 5°, 7°, 11°, 13°, 17°, 19°).",
        "short_description": "OddPartials(19L)",
        "scale_import": scale_55_hs_odd_19l,
        "scale": parseScale(scale_55_hs_odd_19l).scale,
        "equivSteps": 55,
        "note_names": [
          "1",
          "65",
          "33",
          "133",
          "135",
          "17",
          "35",
          "143",
          "9",
          "147",
          "75",
          "19",
          "153",
          "77",
          "39",
          "5",
          "81",
          "165",
          "21",
          "169",
          "85",
          "171",
          "175",
          "11",
          "45",
          "91",
          "187",
          "189",
          "95",
          "3",
          "195",
          "49",
          "99",
          "25",
          "51",
          "13",
          "209",
          "105",
          "27",
          "55",
          "221",
          "7",
          "225",
          "57",
          "231",
          "117",
          "119",
          "15",
          "121",
          "243",
          "245",
          "247",
          "125",
          "63",
          "255",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9a9a",
          "#e9d7d3",
          "#dfffd6",
          "#f4e6f2",
          "#fffae5",
          "#cfcfcf",
          "#ffcba8",
          "#90f9cd",
          "#ffffff",
          "#f8c9c9",
          "#fef5be",
          "#d6f7ff",
          "#cfcfcf",
          "#e9ecc1",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#ddfe95",
          "#ffe5e5",
          "#dbb3ff",
          "#eceae4",
          "#d6f7ff",
          "#ffd270",
          "#dfffd6",
          "#fffae5",
          "#ebd0e0",
          "#ccdbce",
          "#ffe5e5",
          "#e5fff9",
          "#ffffff",
          "#e9d7d3",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#cfcfcf",
          "#e6d7fe",
          "#caf7e3",
          "#ffcba8",
          "#ffffff",
          "#ddfe95",
          "#c3b4d5",
          "#ffe5e5",
          "#fef5be",
          "#d6f7ff",
          "#e9ecc1",
          "#e6d7fe",
          "#ded4d5",
          "#fffae5",
          "#c3ffad",
          "#ffffff",
          "#ffb59a",
          "#dbe6ff",
          "#ffef8a",
          "#ffe5e5",
          "#eceae4"
        ],
        "key_colors_mode": "manual",
        "rSteps": 8,
        "drSteps": 5,
        "hexSize": 38,
        "rotation": -8.2,
        "fundamental": 440,
        "reference_degree": 38,
        "center_degree": 0,
      },
      {
        "name": "81-(47-Limit) < 256° (Sabat: The Tree)",
        "description":
          "81-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 47. This set combines all of the preceding pitches, and adds primes up to 47° and their multiples. The prime limit chosen is the highest prime that allows each pitch to be part of an harmonic chord comprising (at least) identities 1° 3° 5°.",
        "short_description": "OddPartials(47L)",
        "scale_import": scale_81_hs_odd_47l,
        "scale": parseScale(scale_81_hs_odd_47l).scale,
        "equivSteps": 81,
        "note_names": [
          "1",
          "129",
          "65",
          "33",
          "133",
          "135",
          "17",
          "69",
          "35",
          "141",
          "143",
          "9",
          "145",
          "147",
          "37",
          "75",
          "19",
          "153",
          "77",
          "155",
          "39",
          "5",
          "161",
          "81",
          "41",
          "165",
          "21",
          "169",
          "85",
          "171",
          "43",
          "87",
          "175",
          "11",
          "45",
          "91",
          "23",
          "185",
          "93",
          "187",
          "47",
          "189",
          "95",
          "3",
          "195",
          "49",
          "99",
          "25",
          "203",
          "51",
          "205",
          "207",
          "13",
          "209",
          "105",
          "215",
          "27",
          "217",
          "55",
          "221",
          "111",
          "7",
          "225",
          "57",
          "115",
          "231",
          "29",
          "117",
          "235",
          "119",
          "15",
          "121",
          "243",
          "245",
          "123",
          "247",
          "31",
          "125",
          "63",
          "253",
          "255",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff7070",
          "#c9a573",
          "#e9d7d3",
          "#dfffd6",
          "#f4e6f2",
          "#fffae5",
          "#cfcfcf",
          "#95c69b",
          "#ffcba8",
          "#ffb8da",
          "#90f9cd",
          "#ffffff",
          "#b4cbfe",
          "#f8c9c9",
          "#cee3e2",
          "#fef5be",
          "#d6f7ff",
          "#cfcfcf",
          "#e9ecc1",
          "#0afff3",
          "#e6d7fe",
          "#fffae5",
          "#91b195",
          "#ffffff",
          "#f89b87",
          "#ddfe95",
          "#ffe5e5",
          "#dbb3ff",
          "#eceae4",
          "#d6f7ff",
          "#c9a573",
          "#8aafff",
          "#ffd270",
          "#dfffd6",
          "#fffae5",
          "#ebd0e0",
          "#95c69b",
          "#dfebdb",
          "#68f3ec",
          "#ccdbce",
          "#ffb8da",
          "#ffe5e5",
          "#e5fff9",
          "#ffffff",
          "#e9d7d3",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#b0a9fe",
          "#cfcfcf",
          "#e0b49e",
          "#95c69b",
          "#e6d7fe",
          "#caf7e3",
          "#ffcba8",
          "#e8c28c",
          "#ffffff",
          "#0fd2c8",
          "#ddfe95",
          "#c3b4d5",
          "#cee3e2",
          "#ffe5e5",
          "#fef5be",
          "#d6f7ff",
          "#90d597",
          "#e9ecc1",
          "#8aafff",
          "#e6d7fe",
          "#f79cc5",
          "#ded4d5",
          "#fffae5",
          "#c3ffad",
          "#ffffff",
          "#ffb59a",
          "#f89b87",
          "#dbe6ff",
          "#68f3ec",
          "#ffef8a",
          "#ffe5e5",
          "#69ec79",
          "#eceae4"
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 56,
        "center_degree": 0,
        "lumatone_anchor_channel": 2,
        "lumatone_anchor_note": 41,
      },
      {
        "name": "22-(37to47) < 256°",
        "description":
          "22-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 47. This set is a subset of the preceding pitches, including primes 37 through 47 and the pitch classes 1°, 3°, 9°, 27°, 7°, 21°, 63°. The high primes all have their 5 identities.",
        "short_description": "OddPart(37to47)",
        "scale_import": scale_22_hs_odd_37to47,
        "scale": parseScale(scale_22_hs_odd_37to47).scale,
        "equivSteps": 22,
        "note_names": [
          "1",
          "129",
          "141",
          "9",
          "147",
          "37",
          "41",
          "21",
          "43",
          "185",
          "47",
          "3",
          "49",
          "205",
          "215",
          "27",
          "111",
          "7",
          "235",
          "245",
          "123",
          "63",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff7070",
          "#c9a573",
          "#ffb8da",
          "#ffffff",
          "#f8c9c9",
          "#cee3e2",
          "#f89b87",
          "#ffe5e5",
          "#c9a573",
          "#dfebdb",
          "#ffb8da",
          "#ffffff",
          "#f8c9c9",
          "#e0b49e",
          "#e8c28c",
          "#ffffff",
          "#cee3e2",
          "#ffe5e5",
          "#f79cc5",
          "#ffb59a",
          "#f89b87",
          "#ffe5e5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 38,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 15,
        "center_degree": 0,
      },
      {
        "name": "53 < 256° isomorphic",
        "description":
          "53-tone Rational Intonation gamut, based on the set of pitch classes derived from odd harmonic partials not exceeding 256°. To divide each whole tone into 9 parts and each limma in 4 parts, and obtain a near-isomorphic 53-layout, a few additional higher primes and a few pitches from the subdominant series have been added to complete the scale (69, 7/6, 315, 65/48, 177, 23, 19/12, 5/3, 59, 31, 95/48).",
        "short_description": "53-OddPart-iso",
        "scale_import": scale_53_hs_odd_mod,
        "scale": parseScale(scale_53_hs_odd_mod).scale,
        "equivSteps": 53,
        "note_names": [
          "1",
          "65",
          "33",
          "133",
          "135",
          "17",
          "69",
          "35",
          "143",
          "9",
          "147",
          "7/6",
          "75",
          "19",
          "77",
          "39",
          "315",
          "5",
          "81",
          "165",
          "21",
          "169",
          "171",
          "65/48",
          "11",
          "177",
          "45",
          "91",
          "23",
          "189",
          "95",
          "3",
          "49",
          "99",
          "25",
          "19/12",
          "51",
          "13",
          "105",
          "5/3",
          "27",
          "55",
          "7",
          "225",
          "57",
          "231",
          "117",
          "59",
          "15",
          "121",
          "31",
          "63",
          "95/48",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9898",
          "#e9d7d3",
          "#dfffd6",
          "#f4e6f2",
          "#fffae5",
          "#cfcfcf",
          "#95c69b",
          "#ffcba8",
          "#90f9cd",
          "#ffffff",
          "#f8c9c9",
          "#ffe5e5",
          "#fef5be",
          "#d6f7ff",
          "#e9ecc1",
          "#e6d7fe",
          "#ffe8e5",
          "#fffae5",
          "#ffffff",
          "#ddfe95",
          "#ffe5e5",
          "#dbb3ff",
          "#d6f7ff",
          "#e9d7d3",
          "#dfffd6",
          "#d2eee9",
          "#fffae5",
          "#ebd0e0",
          "#95c69b",
          "#ffe5e5",
          "#e5fff9",
          "#ffffff",
          "#f8c9c9",
          "#dfffd6",
          "#fef5be",
          "#d6f7ff",
          "#cfcfcf",
          "#e6d7fe",
          "#ffcba8",
          "#fffae5",
          "#ffffff",
          "#ddfe95",
          "#ffe5e5",
          "#fef5be",
          "#d6f7ff",
          "#e9ecc1",
          "#e6d7fe",
          "#d2eee9",
          "#fffae5",
          "#c3ffad",
          "#68f3ec",
          "#ffe5e5",
          "#e5fff9"
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 40,
        "center_degree": 0,
      }
    ],
  },
  {
    "name": "Rational Intonation (JI)",
    "settings": [
      {
        "name": "53-Tertial (center D)",
        "description":
          "53-tone 3-Limit Rational Intonation scale, consisting of 53 notes per octave derived by tuning a chain of 53 3/2 perfect fifths: 26 are harmonics and 26 are subharmonics of D. This gives a symmetric, enharmonically respelled notation combining two HEJI symbols, tilde and arrow, to indicate alteration by a Syntonic Comma plus a Schisma, which is equal to a Pythagorean Comma. Jing Fang (78–37 BCE), a Chinese music theorist, observed that a sequence of 53 just fifths is very nearly equal to 31 octaves. Compare this tuning to the following tuning based on 5-Limit (with 2 enharmonic proximities added) and to the 53edo temperament.",
        "short_description": "53-JI-3L",
        "scale": [
          "531441/524288",
          "282429536481/274877906944",
          "134217728/129140163",
          "256/243",
          "2187/2048",
          "1162261467/1073741824",
          "34359738368/31381059609",
          "65536/59049",
          "9/8",
          "4782969/4194304",
          "2541865828329/2199023255552",
          "16777216/14348907",
          "32/27",
          "19683/16384",
          "10460353203/8589934592",
          "4294967296/3486784401",
          "8192/6561",
          "81/64",
          "43046721/33554432",
          "22876792454961/17592186044416",
          "2097152/1594323",
          "4/3",
          "177147/131072",
          "94143178827/68719476736",
          "536870912/387420489",
          "1024/729",
          "729/512",
          "387420489/268435456",
          "137438953472/94143178827",
          "262144/177147",
          "3/2",
          "1594323/1048576",
          "847288609443/549755813888",
          "67108864/43046721",
          "128/81",
          "6561/4096",
          "3486784401/2147483648",
          "17179869184/10460353203",
          "32768/19683",
          "27/16",
          "14348907/8388608",
          "7625597484987/4398046511104",
          "8388608/4782969",
          "16/9",
          "59049/32768",
          "31381059609/17179869184",
          "2147483648/1162261467",
          "4096/2187",
          "243/128",
          "129140163/67108864",
          "549755813888/282429536481",
          "1048576/531441",
          "2/1",
        ],
        "equivSteps": 53,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
          "C",
        ],
        "note_colors": [
          "#ffb8b8",
          "#e2caca",
          "#dfffd6",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#dfffd6",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#dfffd6",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#dfffd6",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#dfffd6",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#dfffd6",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#fef5be",
          "#fffae5"
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 440,
        "reference_degree": 40,
        "rSteps": 9,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "center_degree": 9,
        "lumatone_anchor_channel": 3,
        "lumatone_anchor_note": 27,
        "exquis_anchor_note": 9,
      },
      {
        "name": "55-Quintal (Sabat Euler Lattice, center D)",
        "description":
          '55-tone 5-Limit Rational Intonation scale, based on Marc Sabat’s "Euler Lattice Spirals Scenery". Pythagorean diatonic tones are divided in a symmetric pattern of 9 "commas". To divide C 1/1 - D 9/8 add two notes above C: 81/80 and 25/24, then add two more notes one Syntonic Comma above each of these. Similarly, add two notes below D: 10/9 and 27/25; then, add two more notes a Syntonic Comma below each of these. To divide the limmas E-F and B-C, add two successive Syntonic Commas above the lower note and two Commas below the higher note, reaching a point of enharmonic near-equivalence between E and F.',
        "short_description": "55-JI-5L(Euler)",
        "scale_import": scale_55_ji_5l,
        "scale": parseScale(scale_55_ji_5l).scale,
        "equivSteps": 55,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffcbcb",
          "#e9e1b4",
          "#dfd39a",
          "#ddd5a4",
          "#e6e0cb",
          "#c7c1a1",
          "#beb58f",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e9e1b4",
          "#dfd39a",
          "#ddd5a4",
          "#e6e0cb",
          "#c7c1a1",
          "#beb58f",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e9e1b4",
          "#dfd39a",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e9e1b4",
          "#dfd39a",
          "#ddd5a4",
          "#e6e0cb",
          "#c7c1a1",
          "#beb58f",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e9e1b4",
          "#dfd39a",
          "#ddd5a4",
          "#e6e0cb",
          "#c7c1a1",
          "#beb58f",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e9e1b4",
          "#dfd39a",
          "#ddd5a4",
          "#e6e0cb",
          "#c7c1a1",
          "#beb58f",
          "#fef5be",
          "#fffae5",
          "#ffffff",
          "#e9e1b4",
          "#dfd39a",
          "#fef5be",
          "#fffae5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 41,
        "center_degree": 9,
        "lumatone_anchor_channel": 3,
        "lumatone_anchor_note": 27,
        "exquis_anchor_note": 9,
      },
      {
        "name": "41-Septimal-Tertial",
        "description":
          "41-tone 7-Limit Rational Intonation scale by Marc Sabat, inspired by La Monte Young’s Well-Tuned-Piano 12-note tuning. The Pythagorean diatonic tones (C-D, D-E, F-G, G-A, A-B) are each divided Limma-Comma-Limma (i.e., C, D♭, C♯, D), producing a division of the octave into 5 Pythagorean Commas and 12 limmas (including E-F and B-C). Each Limma is divided further into three septimal intervals with sizes 63:64, 48:49, 63:64. The resulting 41 note scale consists of 5 Pythagorean Commas (24c), 12 48:49’s (35c), and 24 Septimal Commas (27c). Compare this tuning to 41edo temperament.",
        "short_description": "41-JI-7L(MS-LMY)",
        "scale_import": scale_41_ji_7l,
        "scale": parseScale(scale_41_ji_7l).scale,
        "equivSteps": 41,
        "note_names": [
          "C",
          "C",
          "D",
          "D",
          "C",
          "C",
          "D",
          "D",
          "D",
          "E",
          "E",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "G",
          "G",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "G",
          "G",
          "A",
          "A",
          "A",
          "B",
          "B",
          "A",
          "A",
          "B",
          "B",
          "B",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9c9c",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 7,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 31,
        "center_degree": 0,
        "lumatone_anchor_channel": 2,
        "lumatone_anchor_note": 42,
        "exquis_anchor_note": 13,
      },
      {
        "name": "41-Septimal-Tertial (Tonnetz Layout)",
        "description":
          "41-tone 7-Limit Rational Intonation scale by Marc Sabat, inspired by La Monte Young’s Well-Tuned-Piano 12-note tuning. The Pythagorean diatonic tones (C-D, D-E, F-G, G-A, A-B) are each divided Limma-Comma-Limma (i.e., C, D♭, C♯, D), producing a division of the octave into 5 Pythagorean Commas and 12 limmas (including E-F and B-C). Each Limma is divided further into three septimal intervals with sizes 63:64, 48:49, 63:64. The resulting 41 note scale consists of 5 Pythagorean Commas (24c), 12 48:49’s (35c), and 24 Septimal Commas (27c).",
        "short_description": "41-JI-7L(MS-LMY)",
        "scale_import": scale_41_ji_7l,
        "scale": parseScale(scale_41_ji_7l).scale,
        "equivSteps": 41,
        "note_names": [
          "C",
          "C",
          "D",
          "D",
          "C",
          "C",
          "D",
          "D",
          "D",
          "E",
          "E",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "G",
          "G",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "G",
          "G",
          "A",
          "A",
          "A",
          "B",
          "B",
          "A",
          "A",
          "B",
          "B",
          "B",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9c9c",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 17,
        "drSteps": 8,
        "hexSize": 42,
        "rotation": -20,
        "fundamental": 440,
        "reference_degree": 31,
        "center_degree": 0,
        "lumatone_anchor_channel": 3,
        "lumatone_anchor_note": 27,
      }, {
        "name": "18-Oliveros Septimal-Quintal",
        "description": "JI tuning system for Pauline Oliveros' accordion (May 1987). The left hand is tuned in 5 limit and the right hand is in 7 limit. The tuning was done by Walter Vergini of Oxnard, CA under the supervision of Alfred Shabda Owen. The tuning system was suggested by Loren Rush.",
        "short_description": "18-JI-7L",
        "scale": [
          "135/128",
          "16/15",
          "9/8",
          "7/6",
          "6/5",
          "5/4",
          "4/3",
          "45/32",
          "64/45",
          "3/2",
          "14/9",
          "8/5",
          "5/3",
          "27/16",
          "7/4",
          "16/9",
          "15/8",
          "15/8",
          "2/1"
        ],
        "equivSteps": 19,
        "note_names": [
          "C",
          "C",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "C"
        ],
        "note_colors": [
          "#ffffff",
          "#fffae5",
          "#dee2da",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#fffae5",
          "#dee2da",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#d0d0d7",
          "#fffae5",
          "#fffae5"
        ],
        "key_labels": "heji",
        "key_colors_mode": "manual",
        "fundamental_color": "#f2e3e3",
        "fundamental": 441,
        "reference_degree": 14,
        "rSteps": 3,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "center_degree": 0,
        "lumatone_anchor_channel": 3,
        "lumatone_anchor_note": 27,
      },
      {
        "name": "31-(7-Limit) Fokker",
        "description":
          "31-tone 7-Limit Rational Intonation scale by Adriaan Fokker, consisting of 31 notes per octave derived from harmonic partial row intervals up to a prime limit of 7. Fokker was an early advocate of extending the conventional tone system beyond 12 notes, and advocated adoption of a 31-tone system. He is also a key figure in Rational Intonation and temperament research, inventing the concept of periodicity blocks. Compare this rational tuning to extended Quarter Comma Meantone and the 31edo temperament.",
        "short_description": "31-JI-7L(Fokker)",
        "scale_import": scale_31_ji_7l_fokker,
        "scale": parseScale(scale_31_ji_7l_fokker).scale,
        "equivSteps": 31,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "E",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "G",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ff9898",
          "#e5b9bb",
          "#e6e0cb",
          "#f4cdc1",
          "#ffcba8",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#f4cdc1",
          "#ffcba8",
          "#fffae5",
          "#e5b9bb",
          "#ffe5e5",
          "#ffffff",
          "#ffd270",
          "#e6e0cb",
          "#f4cdc1",
          "#ffcba8",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#f4cdc1",
          "#ffcba8",
          "#fffae5",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#ffcba8",
          "#fffae5",
          "#f4cdc1",
          "#ffe5e5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 5,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 260.740741,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "31-Divided Fifth (ratios repeating at the 3/2)",
        "description":
          "13-tone 7-Limit Rational Intonation scale, consisting of 13 notes per 3/2 derived from harmonic partial row intervals up to a prime limit of 7. The pattern chosen takes all complete and gapless harmonic and subharmonic divisions of the perfect fifth and perfect fourth within the 23 limit and compiles notes which occur in at least two such divisions. The division of the fifth and two symmetrically placed divisions of the fourth are superposed. The central 1/1 ratio is tuned to Pythagorean D (293.333333 Hz), so that the next cycle begins at A 440 Hz.",
        "short_description": "13-JI-7L-P5",
        "scale_import": scale_13_ji_7l_P5,
        "scale": parseScale(scale_13_ji_7l_P5).scale,
        "equivSteps": 13,
        "note_names": [
          "1/1",
          "16/15",
          "15/14",
          "9/8",
          "8/7",
          "7/6",
          "6/5",
          "5/4",
          "9/7",
          "21/16",
          "4/3",
          "7/5",
          "45/32",
          "3/2",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#e7e7ca",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#e2caca",
          "#ffe5e5",
          "#ffffff",
          "#ece6df",
          "#fffae5",
          "ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 2,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 293.3333333,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "43-(11-Limit) Partch (original ratios)",
        "description":
          "The classic 43-tone 11-Limit Rational Intonation scale by Harry Partch, consisting of 43 divisions per octave derived symmetrically from both harmonic and subharmonic partial rows (otonalities and utonalities) up to a prime limit of 11. The ratio notation follows Partch's original tuning, based on 1/1 = G (392 Hz). Note that the scala file uses the standard reference tone C, so each of Partch’s ratios must be multiplied by 3/2 and normalised to produce his original pitch-heights.",
        "short_description": "43-JI-11L(Partch)",
        "scale_import": scale_43_ji_11l_partchG,
        "scale": parseScale(scale_43_ji_11l_partchG).scale,
        "equivSteps": 43,
        "note_names": [
          "4/3",
          "27/20",
          "11/8",
          "7/5",
          "10/7",
          "16/11",
          "40/27",
          "3/2",
          "32/21",
          "14/9",
          "11/7",
          "8/5",
          "18/11",
          "5/3",
          "27/16",
          "12/7",
          "7/4",
          "16/9",
          "9/5",
          "20/11",
          "11/6",
          "15/8",
          "40/21",
          "64/33",
          "160/81",
          "1/1",
          "81/80",
          "33/32",
          "21/20",
          "16/15",
          "12/11",
          "11/10",
          "10/9",
          "9/8",
          "8/7",
          "7/6",
          "32/27",
          "6/5",
          "11/9",
          "5/4",
          "14/11",
          "9/7",
          "21/16",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ece6df",
          "#ecc9a2",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e2eecd",
          "#dfffd6",
          "#fffae5",
          "#ecc9a2",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ece6df",
          "#dee2da",
          "#cee3e2",
          "#e2eecd",
          "#fffae5",
          "#e2eecd",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#dfffd6",
          "#fffae5",
          "#bae5f7",
          "#e2caca",
          "#ffe5e5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 7,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 392,
        "reference_degree": 25,
        "center_degree": 25,
        "lumatone_anchor_note": 25,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "43-(11-Limit) Partch (degree_0 = 1/1, A 440 Hz, HEJI)",
        "description":
          "Transposition of the 43-tone 11-Limit Rational Intonation scale by Harry Partch, consisting of 43 divisions per octave derived symmetrically from both harmonic and subharmonic partial rows (otonalities and utonalities) up to a prime limit of 11. Partch’s original tuning was based on 1/1 = G, while this version sets 1/1 = C, using the same frequency ratios.",
        "short_description": "43-JI-11L(Partch)",
        "scale_import": scale_43_ji_11l_partch,
        "scale": parseScale(scale_43_ji_11l_partch).scale,
        "equivSteps": 43,
        "note_names": [
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "F",
          "E",
          "F",
          "F",
          "F",
          "F",
          "G",
          "F",
          "G",
          "G",
          "G",
          "G",
          "A",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ece6df",
          "#dee2da",
          "#cee3e2",
          "#e2eecd",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#dfffd6",
          "#fffae5",
          "#bae5f7",
          "#e2caca",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ece6df",
          "#ecc9a2",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e2eecd",
          "#dfffd6",
          "#fffae5",
          "#ecc9a2",
          "#cee3e2",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 7,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 32,
        "center_degree": 0,
      },
      {
        "name": "17-(11-Limit) Wilson",
        "description":
          "17-tone 11-Limit Rational Intonation scale by Erv Wilson, consisting of 17 notes per octave derived from harmonic partial row intervals up to a prime limit of 11. Wilson is one of the most important theorists of microtonal music research, inventing not only the hexagonal isomorphic keyboard layout featured in this web app, but also numerous key theoretical concepts relating to scale formation (moment of symmetry, combination product sets, etc.)",
        "short_description": "17-JI-11L_Wilson",
        "scale_import": scale_17_ji_11l_wilson,
        "scale": parseScale(scale_17_ji_11l_wilson).scale,
        "equivSteps": 17,
        "note_names": [
          "C",
          "C",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "B",
          "B",
          "B",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffbbbb",
          "#e0eccb",
          "#e3f5d0",
          "#ffffff",
          "#ffe5e5",
          "#dfffd6",
          "#fffae5",
          "#ffffff",
          "#dfffd6",
          "#e3f5d0",
          "#ffffff",
          "#e0eccb",
          "#dfffd6",
          "#fffae5",
          "#ffe5e5",
          "#dfffd6",
          "#fffae5"
        ],
        "key_colors_mode": "manual",
        "rSteps": 3,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 260.740741,
        "reference_degree": 0,
        "center_degree": 0,
        "lumatone_anchor_note": 27,
        "lumatone_anchor_channel": 3
      },
      {
        "name": "41-(13-Limit) Breed",
        "description":
          'Graham Breed\'s 41-tone 13-Limit Rational Intonation scale, consisting of 41 notes per octave derived from harmonic partial row intervals up to a prime limit of 13. This 13-Limit scale demonstrates an asymmetric harmonic and partially-subharmonic construction producing a continuous chain of perfect fifths and "quasi-fifths". By its similarity to the other 41-tone scales found here, this version demonstrates the concept of "rational temperament", where enharmonically proximal ratios may substitute for missing notes as slightly mistuned alternates. Compare this tuning to 41edo temperament.',
        "short_description": "41-JI-13L(Breed)",
        "scale": [
          "81/80",
          "33/32",
          "135/128",
          "16/15",
          "13/12",
          "10/9",
          "9/8",
          "8/7",
          "7/6",
          "1215/1024",
          "6/5",
          "39/32",
          "5/4",
          "81/64",
          "9/7",
          "21/16",
          "4/3",
          "27/20",
          "11/8",
          "45/32",
          "729/512",
          "13/9",
          "189/128",
          "3/2",
          "243/160",
          "99/64",
          "405/256",
          "8/5",
          "13/8",
          "5/3",
          "27/16",
          "12/7",
          "7/4",
          "16/9",
          "9/5",
          "11/6",
          "15/8",
          "243/128",
          "27/14",
          "63/32",
          "2/1",
        ],
        "equivSteps": 41,
        "note_names": [
          "*nC",
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "*nD",
          "D",
          "E",
          "D",
          "E",
          "E",
          "E",
          "*nE",
          "E",
          "F",
          "*nF",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "*nG",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
        ],
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#eee9d3",
          "#dee2da",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#eee9d3",
          "#dee2da",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#eee9d3",
          "#d0d0d7",
          "#e6d7fe",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#eee9d3",
          "#dee2da",
          "#e6d7fe",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#dfffd6",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 440,
        "reference_degree": 31,
        "rSteps": 7,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "center_degree": 0,
      },
      {
        "name": "53-(13-Limit) Taylor",
        "description":
          'Cam Taylor’s 53-tone 13-Limit Rational Intonation scale, consisting of 53 symmetrically derived notes per octave derived from harmonic partial row intervals up to a prime limit of 13. This 13-Limit scale demonstrates a symmetric harmonic-subharmonic construction producing a continuous chain of perfect fifths and "quasi-fifths". By its similarity to the other 53-tone scales found here, this version demonstrates the concept of "rational temperament", where enharmonically proximal ratios may substitute for missing notes as slightly mistuned alternates.',
        "short_description": "53-RI-13L_Taylor",
        "scale_import": scale_53_ji_13l_ct,
        "scale": parseScale(scale_53_ji_13l_ct).scale,
        "equivSteps": 53,
        "note_names": [
          "C",
          "C",
          "C",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "C",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e4f6fb",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#cabddb",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e4fbf1",
          "#ffe5e5",
          "#ffffff",
          "#dee2da",
          "#dfffd6",
          "#cabddb",
          "#fffae5",
          "#dee2da",
          "#e6d7fe",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e4f6fb",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#e6d7fe",
          "#cabddb",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e4fbf1",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#dfffd6",
          "#cabddb",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#cee3e2",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 40,
        "center_degree": 0,
      },
    ],
  },
  {
    "name": "Extended Meantone",
    "settings": [
      {
        "name": "31-Vicentino I (1555) 1/4 Comma (g♭-a♯♯♯)",
        "description":
          '31-tone scale in extended 1/4 Comma meantone (probably the tuning used for Nicola Vicentino’s instruments, following his description). Each fifth in the range g♭-a♯♯♯ is narrowed from its JI ratio 2:3 by 1/4 of a Syntonic Comma, so that four successive fifths produce a major third 4:5. Standard 12-tone meantone usually ranges from e♭ to g♯, leaving a so-called "wolf" fifth. By extending the tuning to 31 notes, a circulating well-temperament is produced: the missing c may be replaced by the enharmonically nearly-equivalent pitch b. Note that b *is* equivalent to c!',
        "short_description": "31-MT_VicentinoI",
        "scale_import": scale_31_mt_vicentino,
        "scale": parseScale(scale_31_mt_vicentino).scale,
        "equivSteps": 31,
        "note_names": [
          "c",
          "c",
          "c",
          "d",
          "d",
          "d",
          "d",
          "d",
          "e",
          "e",
          "e",
          "e",
          "e",
          "f",
          "f",
          "f",
          "g",
          "g",
          "g",
          "g",
          "g",
          "a",
          "a",
          "a",
          "a",
          "a",
          "b",
          "b",
          "b",
          "b",
          "b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#e2dfcf",
          "#eee9d3",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#e2dfcf",
          "#eee9d3",
        ],
        "key_colors_mode": "manual",
        "rSteps": 5,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 23,
        "center_degree": 0,
      },
      {
        "name": "38-Vicentino II (1555) Adaptive Meantone/JI",
        "description":
          '19 tones from Extended 1/4 Syntonic Comma Meantone (g♭-b♯) combined with another tuning of the same 19 notes, raised by 1/4 of a Syntonic Comma, to produce perfect fifths. An example of "adaptive" Rational Intonation, this tuning allows triads to be played with 2:3 fifths and 4:5 major thirds or 5:6 minor thirds.',
        "short_description": "38-VicentinoII",
        "scale_import": scale_19_19P5_amt_vicentino,
        "scale": parseScale(scale_19_19P5_amt_vicentino).scale,
        "equivSteps": 38,
        "note_names": [
          "c",
          "c",
          "c",
          "c",
          "d",
          "d",
          "d",
          "d",
          "d",
          "d",
          "e",
          "e",
          "e",
          "e",
          "e",
          "e",
          "f",
          "f",
          "f",
          "f",
          "g",
          "g",
          "g",
          "g",
          "g",
          "g",
          "a",
          "a",
          "a",
          "a",
          "a",
          "a",
          "b",
          "b",
          "b",
          "b",
          "b",
          "b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#d0d0d7",
          "#f8ffeb",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#d0d0d7",
          "#f8ffeb",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#d0d0d7",
          "#f8ffeb",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#d0d0d7",
          "#f8ffeb",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
          "#d0d0d7",
          "#f8ffeb",
          "#ffffff",
          "#ffe5e5",
          "#dee2da",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 6,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -34.5,
        "fundamental": 440,
        "reference_degree": 28,
        "center_degree": 0,
      },
      {
        "name": "36-2/17-Schisma MT (based on Helmholtz)",
        "description":
          "36-tone scale tempering the perfect fifth narrow by 2/17 Schisma (by dividing the ratio 32805/32768, or ca. 2 cents, representing the difference between 8 2:3 perfect fifths and a 4:5, into very small parts). 8 perfect fifths produce a 4:5 major third less 1/17 schisma and nine perfect fifths produce a 5:6 minor third less 1/17 schisma. Based on Hermann von Helmholtz’s 24-note harmonium tuning and Gioseffo Zarlino’s 2/7 Syntonic Comma Meantone.",
        "short_description": "35-MT_Helmholtz",
        "scale_import": scale_36_mt_sabat_helmholtz,
        "scale": parseScale(scale_36_mt_sabat_helmholtz).scale,
        "equivSteps": 36,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "C D",
          "D",
          "D",
          "D",
          "D",
          "D E",
          "E",
          "E",
          "E",
          "E",
          "E F",
          "F",
          "F",
          "F",
          "F",
          "F G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A B",
          "B",
          "B",
          "B",
          "B",
          "B C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#fceec5",
          "#fffae5",
          "#d0d0d7",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#fceec5",
          "#e4e2dd",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e0dbc2",
          "#ffffff",
          "#dee2da",
          "#fceec5",
          "#fffae5",
          "#d0d0d7",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#fceec5",
          "#fffae5",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#fceec5",
          "#e4e2dd",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e0dbc2",
        ],
        "key_colors_mode": "manual",
        "rSteps": 6,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -21.2,
        "fundamental": 440,
        "reference_degree": 27,
        "center_degree": 0,
      },
      {
        "name": "43-1/5-Syntonic Comma MT (dbbb-d###)",
        "description":
          '43-tone scale in extended 1/5 Syntonic Comma meantone. Each fifth in the range d♭♭♭-d♯♯♯ is narrowed from its JI ratio 2:3 by 1/5 of a Syntonic Comma (80:81 = ca. 21.5c), so that five successive fifths produce a major seventh (15/8). Standard 12-tone meantone usually ranges from E♭ to G♯, leaving a so-called "wolf" fifth. By extending the tuning to 43 notes, a circulating well-temperament is produced.',
        "short_description": "43-MT-1_5-SC",
        "scale_import": scale_43_mt,
        "scale": parseScale(scale_43_mt).scale,
        "equivSteps": 43,
        "note_names": [
          "c",
          "♭♭d",
          "♯♯b",
          "♯c",
          "♭d",
          "♭♭♭e",
          "♯♯c",
          "d",
          "♭♭e",
          "♯♯♯c",
          "♯d",
          "♭e",
          "♭♭f",
          "♯♯d",
          "e",
          "♭f",
          "♯♯♯d",
          "♯e",
          "f",
          "♭♭g",
          "♯♯e",
          "♯f",
          "♭g",
          "♭♭♭a",
          "♯♯f",
          "g",
          "♭♭a",
          "♯♯♯f",
          "♯g",
          "♭a",
          "♭♭♭b",
          "♯♯g",
          "a",
          "♭♭b",
          "♯♯♯g",
          "♯a",
          "♭b",
          "♭♭c",
          "♯♯a",
          "b",
          "♭c",
          "♭♭♭d",
          "♯b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#ffe5e5",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#e4fbe6",
          "#dee2da",
          "#ffffff",
          "#ffe5e5",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#cee3e2",
          "#dee2da",
        ],
        "key_colors_mode": "manual",
        "rSteps": 7,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 32,
        "center_degree": 0,
      },
      {
        "name": "55-1/6-Pythagorean Comma MT (abbbb-g####)",
        "description":
          '55-tone scale in extended 1/6 Pythagorean Comma meantone. Each fifth in the range A♭♭♭♭-G♯♯♯♯ is narrowed from its JI ratio 2:3 by 1/6 of a Pythagorean Comma (524288:531441 = ca. 23.5c), so that six successive fifths produce a Pythagorean tritone (512:729). Standard 12-tone meantone usually ranges from E♭ to G♯, leaving a so-called "wolf" fifth. By extending the tuning to 55 notes, a circulating well-temperament is produced.',
        "short_description": "43-MT-1_5-SC",
        "scale_import": scale_55_mt,
        "scale": parseScale(scale_55_mt).scale,
        "equivSteps": 55,
        "note_names": [
          "c",
          "♭♭d",
          "♭♭♭♭e",
          "♯♯b",
          "♯c",
          "♭d",
          "♭♭♭e",
          "♯♯♯b",
          "♯♯c",
          "d",
          "♭♭e",
          "♭♭♭f",
          "♯♯♯c",
          "♯d",
          "♭e",
          "♭♭f",
          "♯♯♯♯c",
          "♯♯d",
          "e",
          "♭f",
          "♭♭♭g",
          "♯♯♯d",
          "♯e",
          "f",
          "♭♭g",
          "♭♭♭♭a",
          "♯♯e",
          "♯f",
          "♭g",
          "♭♭♭a",
          "♯♯♯e",
          "♯♯f",
          "g",
          "♭♭a",
          "♭♭♭♭b",
          "♯♯♯f",
          "♯g",
          "♭a",
          "♭♭♭b",
          "♯♯♯♯f",
          "♯♯g",
          "a",
          "♭♭b",
          "♭♭♭c",
          "♯♯♯g",
          "♯a",
          "♭b",
          "♭♭c",
          "♯♯♯♯g",
          "♯♯a",
          "b",
          "♭c",
          "♭♭♭d",
          "♯♯♯a",
          "♯b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#f8ffeb",
          "#dee2da",
          "#d0d0d7",
          "#dce1d0",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 41,
        "center_degree": 0,
      },
    ],
  },
  {
    "name": "Equal Divisions",
    "settings": [
      {
        "name": "19edo (Salinas 1577)",
        "description":
          '19-tone equal tempered scale consisting of 19 sonically equal divisions per octave ("edo"), similar to 1/3-Syntonic Comma meantone. System was first described by Francisco de Salinas in 1577. Step-size is 63.2 cents.',
        "short_description": "19edo (Salinas)",
        "scale_import": scale_19_edo,
        "scale": parseScale(scale_19_edo).scale,
        "equivSteps": 19,
        "note_names": [
          "c",
          "♯c",
          "♭d",
          "d",
          "♯d",
          "♭e",
          "e",
          "♯e ♭f",
          "f",
          "♯f",
          "♭g",
          "g",
          "♯g",
          "♭a",
          "a",
          "♯a",
          "♭b",
          "b",
          "♯b ♭c",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#e1e1e0",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#e1e1e0",
        ],
        "key_colors_mode": "manual",
        "rSteps": 3,
        "drSteps": 2,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 14,
        "center_degree": 0,
      },
      {
        "name": "19edo (enharmonic Septimal notation)",
        "description":
          "19-tone equal tempered scale consisting of 19 sonically equal divisions per octave, similar to 1/3-Syntonic Comma meantone. System was first described by Francisco de Salinas in 1577. Step-size is 63.2 cents.",
        "short_description": "19edo (Salinas)",
        "scale_import": scale_19_edo,
        "scale": parseScale(scale_19_edo).scale,
        "equivSteps": 19,
        "note_names": [
          "c",
          "c d",
          "c d",
          "d",
          "d e",
          "d e",
          "e",
          "e f",
          "f",
          "f g",
          "f g",
          "g",
          "g a",
          "g a",
          "a",
          "a b",
          "a b",
          "b",
          "b c",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#e1e1e0",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#dee2da",
          "#d0d0d7",
          "#ffffff",
          "#e1e1e0",
        ],
        "key_colors_mode": "manual",
        "rSteps": 3,
        "drSteps": 2,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 14,
        "center_degree": 0,
      },
      {
        "name": "22edo (HEJI)",
        "description":
          "22-tone equal tempered scale consisting of 22 sonically equal divisions per octave. The HEJI notation indicates how this temperament may be considered to present a distorted approximation of 5-limit JI.",
        "short_description": "22edo",
        "scale_import": scale_22_edo,
        "scale": parseScale(scale_22_edo).scale,
        "equivSteps": 22,
        "note_names": [
          "C",
          "D",
          "C D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "F",
          "F G",
          "F G",
          "F G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "B",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#fffae5",
          "#ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 17,
        "center_degree": 0,
      },
      {
        "name": "31edo (gbb-a##)",
        "description":
          "31-tone equal tempered scale consisting of 31 sonically equal divisions per octave. Similar to 1/4-Syntonic Comma meantone, the system was first described by Lemme Rossi in 1666, although Vicentino effectively proposed it in 1555. Step-size is 38.7 cents.",
        "short_description": "31edo",
        "scale_import": scale_31_edo,
        "scale": parseScale(scale_31_edo).scale,
        "equivSteps": 31,
        "note_names": [
          "c",
          "♭♭d",
          "♯c",
          "♭d",
          "♯♯c",
          "d",
          "♭♭e",
          "♯d",
          "♭e",
          "♯♯d",
          "e",
          "♭f",
          "♯e",
          "f",
          "♭♭g",
          "♯f",
          "♭g",
          "♯♯f",
          "g",
          "♭♭a",
          "♯g",
          "♭a",
          "♯♯g",
          "a",
          "♭♭b",
          "♯a",
          "♭b",
          "♯♯a",
          "b",
          "♭c",
          "♯b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#e2dfcf",
          "#eee9d3",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#e2dfcf",
          "#eee9d3",
        ],
        "key_colors_mode": "manual",
        "rSteps": 5,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 23,
        "center_degree": 0,
      },
      {
        "name": "31edo (quartertone notation)",
        "description":
          "31-tone equal tempered scale consisting of 31 sonically equal divisions per octave. Similar to 1/4-Syntonic Comma meantone, the system was first described by Lemme Rossi in 1666, although Vicentino effectively proposed it in 1555. Step-size is 38.7 cents.",
        "short_description": "31edo",
        "scale_import": scale_31_edo,
        "scale": parseScale(scale_31_edo).scale,
        "equivSteps": 31,
        "note_names": [
          "c",
          "c",
          "♯c",
          "♭d",
          "d",
          "d",
          "d",
          "♯d",
          "♭e",
          "e",
          "e",
          "e ♭f",
          "♯e f",
          "f",
          "f",
          "♯f",
          "♭g",
          "g",
          "g",
          "g",
          "♯g",
          "♭a",
          "a",
          "a",
          "a",
          "♯a",
          "♭b",
          "b",
          "b",
          "b ♭c",
          "♯b c",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#e7e9d7",
          "#e5e2db",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#e7e9d7",
          "#e5e2db",
        ],
        "key_colors_mode": "manual",
        "rSteps": 5,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 23,
        "center_degree": 0,
      },
      {
        "name": "31edo (in Vicentino Notation, 1555)",
        "description":
          "31-tone equal tempered scale consisting of 31 sonically equal divisions per octave. Similar to 1/4-Syntonic Comma meantone, the system was first described by Lemme Rossi in 1666, although Vicentino effectively proposed it in 1555. Using a notation invented by Nicola Vicentino.",
        "short_description": "31edo",
        "scale_import": scale_31_edo,
        "scale": parseScale(scale_31_edo).scale,
        "equivSteps": 31,
        "note_names": [
          "c",
          "c",
          "c",
          "d",
          "d",
          "d",
          "d",
          "d",
          "e",
          "e",
          "e",
          "e",
          "e",
          "f",
          "f",
          "f",
          "g",
          "g",
          "g",
          "g",
          "g",
          "a",
          "a",
          "a",
          "a",
          "a",
          "b",
          "b",
          "b",
          "b",
          "b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
          "#e2dfcf",
          "#dddae2",
          "#f9f7eb",
          "#eff4e7",
          "#eee9d3",
        ],
        "key_colors_mode": "manual",
        "rSteps": 5,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 23,
        "center_degree": 0,
      }, {
        "name": "36ed2",
        "description": "Octave divided into 36 equal steps",
        "short_description": "35-MT_Helmholtz",
        "scale": [
          "33.3",
          "66.7",
          "100.0",
          "133.3",
          "166.7",
          "200.0",
          "233.3",
          "266.7",
          "300.0",
          "333.3",
          "366.7",
          "400.0",
          "433.3",
          "466.7",
          "500.0",
          "533.3",
          "566.7",
          "600.0",
          "633.3",
          "666.7",
          "700.0",
          "733.3",
          "766.7",
          "800.0",
          "833.3",
          "866.7",
          "900.0",
          "933.3",
          "966.7",
          "1000.0",
          "1033.3",
          "1066.7",
          "1100.0",
          "1133.3",
          "1166.7",
          "1200.0"
        ],
        "equivSteps": 36,
        "note_names": [
          "C",
          "C+33",
          "C−33",
          "C",
          "C+33",
          "D−33",
          "D",
          "D+33",
          "E−33",
          "E",
          "E+33",
          "E−33",
          "E",
          "E+33",
          "F−33",
          "F",
          "F+33",
          "F−33",
          "F",
          "F+33",
          "G−33",
          "G",
          "G+33",
          "G−33",
          "G",
          "G+33",
          "A−33",
          "A",
          "A+33",
          "B−33",
          "B",
          "B+33",
          "B−33",
          "B",
          "B+33",
          "C−33"
        ],
        "note_colors": [
          "#ff9e9e",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#d3c6c5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#d3c6c5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5"
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "prime_family_colors": null,
        "fundamental": 440,
        "reference_degree": 27,
        "rSteps": 6,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -21.2,
        "center_degree": 0
      }, {
        "name": "36ed2-rationalised-to-7lim",
        "description": "Octave divided into 36 equal steps rationalised to 7-limit HEJI notes.",
        "short_description": "35-MT_Helmholtz",
        "scale": [
          "64/63",
          "28/27",
          "256/243",
          "243/224",
          "567/512",
          "9/8",
          "8/7",
          "7/6",
          "32/27",
          "2048/1701",
          "896/729",
          "81/64",
          "9/7",
          "21/16",
          "4/3",
          "256/189",
          "112/81",
          "729/512",
          "81/56",
          "189/128",
          "3/2",
          "32/21",
          "14/9",
          "128/81",
          "729/448",
          "1701/1024",
          "27/16",
          "12/7",
          "7/4",
          "16/9",
          "1024/567",
          "448/243",
          "243/128",
          "27/14",
          "63/32",
          "1200.0"
        ],
        "equivSteps": 36,
        "note_names": [
          "C",
          "C",
          "D",
          "D",
          "C",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "E",
          "E",
          "F",
          "F",
          "F",
          "G",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "G",
          "A",
          "A",
          "A",
          "B",
          "B",
          "B",
          "C",
          "B",
          "B",
          "C"
        ],
        "note_colors": [
          "#ff9e9e",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#d3c6c5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#dee2da",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#ffe5e5",
          "#ffffff",
          "#e5b9bb",
          "#d3c6c5",
          "#d0d0d7",
          "#bfaaa9",
          "#d3c6c5",
          "#ffffff",
          "#e5b9bb",
          "#ffe5e5"
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "prime_family_colors": null,
        "fundamental": 440,
        "reference_degree": 27,
        "rSteps": 6,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -21.2,
        "center_degree": 0
      },
      {
        "name": "41edo (Septimal-Tertial Notation)",
        "description":
          "41-tone equal tempered scale consisting of 41 sonically equal divisions per octave. This is the smallest of the equal temperaments in which the lower primes 3, 5, 7, 11, 13 are all presented with minimal mistuning. Step-size is 29.3 cents, close to a Septimal Comma.",
        "short_description": "41edo",
        "scale_import": scale_41_edo,
        "scale": parseScale(scale_41_edo).scale,
        "equivSteps": 41,
        "note_names": [
          "C",
          "C",
          "D",
          "D",
          "C",
          "C",
          "D",
          "D",
          "D",
          "E",
          "E",
          "D",
          "D",
          "E",
          "E",
          "E",
          "F",
          "F",
          "F",
          "G",
          "G",
          "F",
          "F",
          "G",
          "G",
          "G",
          "A",
          "A",
          "G",
          "G",
          "A",
          "A",
          "A",
          "B",
          "B",
          "A",
          "A",
          "B",
          "B",
          "B",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#d0d6e1",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#d0d6e1",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#d0d6e1",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#d0d6e1",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#d0d6e1",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 7,
        "drSteps": 3,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 31,
        "center_degree": 0,
      },
      {
        "name": "43edo (Sauveur 1696, dbbb-d###)",
        "description":
          "43-tone equal tempered scale consisting of 43 sonically equal divisions per octave. Similar to 1/5-Syntonic Comma Meantone, the system was described by Joseph Sauveur in 1696. Step-size (named méride by Sauveur) is 27.9 cents.",
        "short_description": "43edo",
        "scale_import": scale_43_edo,
        "scale": parseScale(scale_43_edo).scale,
        "equivSteps": 43,
        "note_names": [
          "c",
          "♭♭d",
          "♯♯b",
          "♯c",
          "♭d",
          "♭♭♭e",
          "♯♯c",
          "d",
          "♭♭e",
          "♯♯♯c",
          "♯d",
          "♭e",
          "♭♭f",
          "♯♯d",
          "e",
          "♭f",
          "♯♯♯d",
          "♯e",
          "f",
          "♭♭g",
          "♯♯e",
          "♯f",
          "♭g",
          "♭♭♭a",
          "♯♯f",
          "g",
          "♭♭a",
          "♯♯♯f",
          "♯g",
          "♭a",
          "♭♭♭b",
          "♯♯g",
          "a",
          "♭♭b",
          "♯♯♯g",
          "♯a",
          "♭b",
          "♭♭c",
          "♯♯a",
          "b",
          "♭c",
          "♭♭♭d",
          "♯b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#ffe5e5",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#e4fbe6",
          "#dee2da",
          "#ffffff",
          "#ffe5e5",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#d0d0d7",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#cee3e2",
          "#dee2da",
        ],
        "key_colors_mode": "manual",
        "rSteps": 7,
        "drSteps": 4,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 32,
        "center_degree": 0,
      },
      {
        "name": "53edo (Mercator/Newton, Quintal-Tertial Notation)",
        "description":
          "53-tone equal tempered scale consisting of 53 sonically equal divisions per octave. Step-size is 22.6 cents (Holdrian or Mercator Comma), lying in between the Pythagorean and Syntonic Commas and therefore providing an excellent approximation of 5-Limit Rational Intonation.",
        "short_description": "53edo",
        "scale_import": scale_53_edo,
        "scale": parseScale(scale_53_edo).scale,
        "equivSteps": 53,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "C",
          "C D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E F",
          "E F",
          "E F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B C",
          "B C",
          "B C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e8d7b5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#e1e1e0",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e8d7b5",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 4,
        "hexSize": 40,
        "rotation": -16.102113751,
        "fundamental": 260.772,
        "fundamental": 440,
        "reference_degree": 40,
        "center_degree": 0,
      },
      {
        "name": "53edo (Tonnetz Layout)",
        "description":
          "53-tone equal tempered scale consisting of 53 sonically equal divisions per octave. Step-size is 22.6 cents (Holdrian or Mercator Comma), presented in a lattice layout as pioneered by Leonhard Euler in his Tentamen Novae Theoriae Musicae (1739).",
        "short_description": "53edo",
        "scale_import": scale_53_edo,
        "scale": parseScale(scale_53_edo).scale,
        "equivSteps": 53,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "C",
          "C D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E F",
          "E F",
          "E F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B C",
          "B C",
          "B C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e8d7b5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#e1e1e0",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#ebc7ad",
          "#ffe5e5",
          "#d0d0d7",
          "#dee2da",
          "#f8ffeb",
          "#fceec5",
          "#fffae5",
          "#ffffff",
          "#e2caca",
          "#e8d7b5",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 31,
        "drSteps": 17,
        "hexSize": 42,
        "rotation": -6,
        "fundamental": 440,
        "reference_degree": 40,
        "center_degree": 0,
      },
      {
        "name": "55edo (Telemann 1767, abbbb-g####)",
        "description":
          "55-tone equal tempered scale consisting of 55 sonically equal divisions per octave. Similar to 1/6-Pythagorean Comma meantone. Step-size is 21.8 cents.",
        "short_description": "55edo",
        "scale_import": scale_55_edo,
        "scale": parseScale(scale_55_edo).scale,
        "equivSteps": 55,
        "note_names": [
          "c",
          "♭♭d",
          "♭♭♭♭e",
          "♯♯b",
          "♯c",
          "♭d",
          "♭♭♭e",
          "♯♯♯b",
          "♯♯c",
          "d",
          "♭♭e",
          "♭♭♭f",
          "♯♯♯c",
          "♯d",
          "♭e",
          "♭♭f",
          "♯♯♯♯c",
          "♯♯d",
          "e",
          "♭f",
          "♭♭♭g",
          "♯♯♯d",
          "♯e",
          "f",
          "♭♭g",
          "♭♭♭♭a",
          "♯♯e",
          "♯f",
          "♭g",
          "♭♭♭a",
          "♯♯♯e",
          "♯♯f",
          "g",
          "♭♭a",
          "♭♭♭♭b",
          "♯♯♯f",
          "♯g",
          "♭a",
          "♭♭♭b",
          "♯♯♯♯f",
          "♯♯g",
          "a",
          "♭♭b",
          "♭♭♭c",
          "♯♯♯g",
          "♯a",
          "♭b",
          "♭♭c",
          "♯♯♯♯g",
          "♯♯a",
          "b",
          "♭c",
          "♭♭♭d",
          "♯♯♯a",
          "♯b",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#fffae5",
          "#dee2da",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#e4fbe6",
          "#f8ffeb",
          "#dee2da",
          "#d0d0d7",
          "#dce1d0",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#ffe5e5",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
          "#d0d0d7",
          "#ffe5e5",
          "#cee3e2",
          "#fffae5",
          "#ffffff",
          "#d0d0d7",
          "#dce1d0",
          "#f8ffeb",
          "#dee2da",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 41,
        "center_degree": 0,
      },
      {
        "name": "72edo (Sims/Tenney)",
        "description":
          "72-tone equal tempered scale consisting of 72 sonically equal divisions per octave, multiple of 12edo closely approximating 11-Limit JI. Step-size is 16 2/3 cents.",
        "short_description": "72edo",
        "scale_import": scale_72_edo,
        "scale": parseScale(scale_72_edo).scale,
        "equivSteps": 72,
        "note_names": [
          "C",
          "C",
          "C",
          "C",
          "C",
          "C",
          "C D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D",
          "D E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E",
          "E F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F",
          "F G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G",
          "G A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A",
          "A B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B",
          "B C",
          "C",
          "C",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbe6",
          "#ffe5e5",
          "#fffae5",
          "#d0d0d7",
          "#dee2da",
          "#e2caca",
          "#cee3e2",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbe6",
          "#ffe5e5",
          "#fffae5",
          "#d0d0d7",
          "#dee2da",
          "#e2caca",
          "#cee3e2",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbf1",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbe6",
          "#ffe5e5",
          "#fffae5",
          "#d0d0d7",
          "#dee2da",
          "#e2caca",
          "#cee3e2",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbe6",
          "#ffe5e5",
          "#fffae5",
          "#d0d0d7",
          "#dee2da",
          "#e2caca",
          "#cee3e2",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbe6",
          "#ffe5e5",
          "#fffae5",
          "#d0d0d7",
          "#dee2da",
          "#e2caca",
          "#cee3e2",
          "#ffe5e5",
          "#fffae5",
          "#ffffff",
          "#dee2da",
          "#e2caca",
          "#e4fbf1",
          "#ffe5e5",
          "#fffae5",
        ],
        "key_colors_mode": "manual",
        "rSteps": 12,
        "drSteps": 7,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 54,
        "center_degree": 0,
      },
      {
        "name": "205ed2 (TonalPlexus)",
        "description":
          "Octave divided into 205 equal steps in a layout similar to the Tonal Plexus multichannel MIDI controller, which uses five cycles of 41ed2 to closely approximate many harmonic relationships. Note names are the MIDI note numbers on channel pairs a/b mapped to a single 205ed2 block. The Tonal Plexus has 6 blocks, using Channels 3-4, 5-6, 7-8, 9-10. 11-12, 13-14. Note 7 on Ch 9 is mapped to hexatone central degree.",
        "short_description": "OddPartialPC-47L",
        "scale": [
          "5.9",
          "11.7",
          "17.6",
          "23.4",
          "29.3",
          "35.1",
          "41.0",
          "46.8",
          "52.7",
          "58.5",
          "64.4",
          "70.2",
          "76.1",
          "82.0",
          "87.8",
          "93.7",
          "99.5",
          "105.4",
          "111.2",
          "117.1",
          "122.9",
          "128.8",
          "134.6",
          "140.5",
          "146.3",
          "152.2",
          "158.0",
          "163.9",
          "169.8",
          "175.6",
          "181.5",
          "187.3",
          "193.2",
          "199.0",
          "204.9",
          "210.7",
          "216.6",
          "222.4",
          "228.3",
          "234.1",
          "240.0",
          "245.9",
          "251.7",
          "257.6",
          "263.4",
          "269.3",
          "275.1",
          "281.0",
          "286.8",
          "292.7",
          "298.5",
          "304.4",
          "310.2",
          "316.1",
          "322.0",
          "327.8",
          "333.7",
          "339.5",
          "345.4",
          "351.2",
          "357.1",
          "362.9",
          "368.8",
          "374.6",
          "380.5",
          "386.3",
          "392.2",
          "398.0",
          "403.9",
          "409.8",
          "415.6",
          "421.5",
          "427.3",
          "433.2",
          "439.0",
          "444.9",
          "450.7",
          "456.6",
          "462.4",
          "468.3",
          "474.1",
          "480.0",
          "485.9",
          "491.7",
          "497.6",
          "503.4",
          "509.3",
          "515.1",
          "521.0",
          "526.8",
          "532.7",
          "538.5",
          "544.4",
          "550.2",
          "556.1",
          "562.0",
          "567.8",
          "573.7",
          "579.5",
          "585.4",
          "591.2",
          "597.1",
          "602.9",
          "608.8",
          "614.6",
          "620.5",
          "626.3",
          "632.2",
          "638.0",
          "643.9",
          "649.8",
          "655.6",
          "661.5",
          "667.3",
          "673.2",
          "679.0",
          "684.9",
          "690.7",
          "696.6",
          "702.4",
          "708.3",
          "714.1",
          "720.0",
          "725.9",
          "731.7",
          "737.6",
          "743.4",
          "749.3",
          "755.1",
          "761.0",
          "766.8",
          "772.7",
          "778.5",
          "784.4",
          "790.2",
          "796.1",
          "802.0",
          "807.8",
          "813.7",
          "819.5",
          "825.4",
          "831.2",
          "837.1",
          "842.9",
          "848.8",
          "854.6",
          "860.5",
          "866.3",
          "872.2",
          "878.0",
          "883.9",
          "889.8",
          "895.6",
          "901.5",
          "907.3",
          "913.2",
          "919.0",
          "924.9",
          "930.7",
          "936.6",
          "942.4",
          "948.3",
          "954.1",
          "960.0",
          "965.9",
          "971.7",
          "977.6",
          "983.4",
          "989.3",
          "995.1",
          "1001.0",
          "1006.8",
          "1012.7",
          "1018.5",
          "1024.4",
          "1030.2",
          "1036.1",
          "1042.0",
          "1047.8",
          "1053.7",
          "1059.5",
          "1065.4",
          "1071.2",
          "1077.1",
          "1082.9",
          "1088.8",
          "1094.6",
          "1100.5",
          "1106.3",
          "1112.2",
          "1118.0",
          "1123.9",
          "1129.8",
          "1135.6",
          "1141.5",
          "1147.3",
          "1153.2",
          "1159.0",
          "1164.9",
          "1170.7",
          "1176.6",
          "1182.4",
          "1188.3",
          "1194.1",
          "1200.0",
        ],
        "equivSteps": 205,
        "note_names": [
          "a7",
          "a8",
          "a9",
          "a10",
          "a11",
          "a12",
          "a13",
          "a14",
          "a15",
          "a16",
          "a17-18",
          "a19",
          "a20",
          "a21",
          "a22",
          "a23",
          "a24",
          "a25",
          "a26",
          "a27",
          "a28",
          "a29",
          "a30",
          "a31",
          "a32",
          "a33",
          "a34",
          "a35",
          "a36",
          "a37",
          "a38",
          "a39",
          "a40",
          "a41",
          "a42",
          "a43",
          "a44",
          "a45",
          "a46",
          "a47",
          "a48",
          "a49",
          "a50",
          "a51",
          "a52",
          "a53",
          "a54",
          "a55",
          "a56",
          "a57",
          "a58",
          "a59",
          "a60",
          "a61",
          "a62",
          "a63",
          "a64",
          "a65",
          "a66",
          "a67",
          "a68-69",
          "a70",
          "a71",
          "a72",
          "a73",
          "a74",
          "a75",
          "a76",
          "a77",
          "a78",
          "a79",
          "a80",
          "a81",
          "a82",
          "a83",
          "a84",
          "a85",
          "a86",
          "a87",
          "a88",
          "a89",
          "a90",
          "a91",
          "a92",
          "a93",
          "a94",
          "a95",
          "a96",
          "a97",
          "a98",
          "a99",
          "a100",
          "a101",
          "a102",
          "a103",
          "a104-b0",
          "b1",
          "b2",
          "b3",
          "b4",
          "b5",
          "b6",
          "b7",
          "b8",
          "b9",
          "b10",
          "b11",
          "b12",
          "b13",
          "b14",
          "b15",
          "b16",
          "b17",
          "b18",
          "b19",
          "b20",
          "b21",
          "b22",
          "b23",
          "b24",
          "b25",
          "b26",
          "b27",
          "b28",
          "b29",
          "b30",
          "b31",
          "b32",
          "b33",
          "b34",
          "b35-36",
          "b37",
          "b38",
          "b39",
          "b40",
          "b41",
          "b42",
          "b43",
          "b44",
          "b45",
          "b46",
          "b47",
          "b48",
          "b49",
          "b50",
          "b51-52",
          "b53",
          "b54",
          "b55",
          "b56",
          "b57",
          "b58",
          "b59",
          "b60",
          "b61",
          "b62",
          "b63",
          "b64",
          "b65",
          "b66",
          "b67",
          "b68",
          "b69",
          "b70",
          "b71",
          "b72",
          "b73",
          "b74",
          "b75",
          "b76",
          "b77",
          "b78",
          "b79",
          "b80",
          "b81",
          "b82",
          "b83",
          "b84",
          "b85",
          "b86",
          "b87-88",
          "b89",
          "b90",
          "b91",
          "b92",
          "b93",
          "b94",
          "b95",
          "b96",
          "b97",
          "b98",
          "b99",
          "b100",
          "b101",
          "b102",
          "b103",
          "b104",
          "b105",
          "a0",
          "a1",
          "a2",
          "a3",
          "a4",
          "a5",
          "a6",
        ],
        "note_colors": [
          "#ffe0e0",
          "#ffffff",
          "#ffffff",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#342772",
          "#342772",
          "#342772",
          "#1d115a",
          "#1d115a",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#443f3c",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#342772",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#6db7fd",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#bfbfbf",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ffffff",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#ccdbd7",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#dddada",
          "#ffffff",
          "#ffffff",
        ],
        "key_labels": "note_names",
        "key_colors_mode": "manual",
        "fundamental_color": "#ffdbe8",
        "fundamental": 260.740741,
        "reference_degree": 0,
        "rSteps": 18,
        "drSteps": 17,
        "hexSize": 32,
        "rotation": -30,
        "center_degree": 0,
      },
      {
        "name": "55-Heart of Tones",
        "description":
          '55-tone layout of 1200edo (1 cent steps) based on Pauline Oliveros’s "Heart of Tones". The central tone D expands outward by about a semitone on each side.',
        "short_description": "55-Oliveros",
        "scale_import": scale_55cents,
        "scale": parseScale(scale_55cents).scale,
        "equivSteps": 55,
        "note_names": [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "25",
          "25",
          "26",
          "27",
          "-27",
          "-26",
          "-25",
          "-24",
          "-23",
          "-22",
          "-21",
          "-20",
          "-19",
          "-18",
          "-17",
          "-16",
          "-15",
          "-14",
          "-13",
          "-12",
          "-11",
          "-10",
          "-9",
          "-8",
          "-7",
          "-6",
          "-5",
          "-4",
          "-3",
          "-2",
          "-1",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffdbdb",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#f5ffe0",
          "#fbf6e0",
          "#ffffff",
          "#d8f7fd",
          "#ddfde3",
          "#bab4c0",
          "#adadad",
          "#b5a5ca",
          "#ada5c0",
          "#f5ffe0",
          "#fbf6e0",
        ],
        "key_colors_mode": "manual",
        "rSteps": 9,
        "drSteps": 5,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 293.333333,
        "reference_degree": 0,
        "center_degree": 0,
      },
    ],
  },
  {
    "name": "Interval Testing",
    "settings": [
      {
        "name": "By Approximate Syntonic Comma (22 cents)",
        "description":
          'One step = 1 cent, right-up moves approximately by one Syntonic Comma, right-down by one cent. Provided to experiment with fine tuning intervals. Notice the unusual scale definition, which repeats at 1 cent intervals. The "Octaves/Equaves" setting for Key Labels is used to indicate the cents deviations as small numbers in the top right corner of each hexagonal touch key.',
        "short_description": "22cents",
        "scale_import": scale_1cent,
        "scale": parseScale(scale_1cent).scale,
        "equivSteps": 1,
        "note_names": ["-"],
        "key_labels": "no_labels",
        "show_equaves": true,
        "note_colors": [],
        "key_colors_mode": "spectrum",
        "fundamental_color": "#ffdbe8",
        "rSteps": 22,
        "drSteps": 1,
        "hexSize": 28,
        "rotation": -29.3577535,
        "fundamental": 240,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "By Approximate Diesis (41 cents)",
        "description":
          'One step = 1 cent, right-up moves approximately by one Diesis (41 cents), right-down by one cent. Provided to experiment with fine tuning intervals. Notice the unusual scale definition, which repeats at 1 cent intervals. The "Octaves/Equaves" setting for Key Labels is used to indicate the cents deviations as small numbers in the top right corner of each hexagonal touch key.',
        "short_description": "41cents",
        "scale_import": scale_1cent,
        "scale": parseScale(scale_1cent).scale,
        "equivSteps": 1,
        "note_names": ["-"],
        "key_labels": "no_labels",
        "show_equaves": true,
        "note_colors": [],
        "key_colors_mode": "spectrum",
        "fundamental_color": "#ffdbe8",
        "rSteps": 41,
        "drSteps": 1,
        "hexSize": 28,
        "rotation": -29.3577535,
        "fundamental": 240,
        "reference_degree": 0,
        "center_degree": 0,
      },
      {
        "name": "Harp Layout",
        "description": "22-tone layout for testing harp pedal combinations.",
        "scale_import": scale_harp,
        "short_description": "HarpLayout",
        "scale": parseScale(scale_harp).scale,
        "equivSteps": 22,
        "note_names": [
          "C",
          "D",
          "B",
          "C",
          "D",
          "E",
          "F",
          "D",
          "E",
          "F",
          "G",
          "E",
          "F",
          "G",
          "A",
          "-",
          "G",
          "A",
          "B",
          "C",
          "A",
          "B",
        ],
        "key_labels": "note_names",
        "note_colors": [
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#dee2da",
          "#ffffff",
          "#d0d0d7",
          "#d0d0d7",
          "#dee2da",
          "#ffffff",
          "#ffffff",
          "#d0d0d7",
          "#dee2da",
          "#dee2da",
          "#ffffff",
          "#d0d0d7",
          "#999999",
          "#dee2da",
          "#ffffff",
          "#d0d0d7",
          "#d0d0d7",
          "#dee2da",
          "#ffffff",
        ],
        "key_colors_mode": "manual",
        "rSteps": 4,
        "drSteps": 1,
        "hexSize": 42,
        "rotation": -16.102113751,
        "fundamental": 440,
        "reference_degree": 17,
        "center_degree": 0,
      },
    ],
  },
];

export default presets;

export const default_settings = presets[0].settings[0];
